export const DictionaryPhotoshop_fr_FR = [
    {
        id: 1,
        label: 'Photoshop > A propos de Photoshop...',
        placement: 'MenuBar',
        name: 'A propos de Photoshop...',
    },
    {
        id: 10,
        label: 'Fichier > Nouveau...',
        placement: 'MenuBar',
        name: 'Nouveau...',
    },
    {
        id: 20,
        label: 'Fichier > Ouvrir...',
        placement: 'MenuBar',
        name: 'Ouvrir...',
    },
    {
        id: 22,
        label: "Fichier > Ouvrir en tant qu'objet dynamique...",
        placement: 'MenuBar',
        name: "Ouvrir en tant qu'objet dynamique...",
    },
    {
        id: 30,
        label: 'Fichier > Enregistrer',
        placement: 'MenuBar',
        name: 'Enregistrer',
    },
    {
        id: 31,
        label: 'Fichier > Fermer',
        placement: 'MenuBar',
        name: 'Fermer',
    },
    {
        id: 32,
        label: 'Fichier > Enregistrer sous...',
        placement: 'MenuBar',
        name: 'Enregistrer sous...',
    },
    {
        id: 33,
        label: 'Fichier > Enregistrer une copie...',
        placement: 'MenuBar',
        name: 'Enregistrer une copie...',
    },
    {
        id: 34,
        label: 'Fichier > Version précédente',
        placement: 'MenuBar',
        name: 'Version précédente',
    },
    {
        id: 36,
        label: 'Photoshop > Quitter Photoshop',
        placement: 'MenuBar',
        name: 'Quitter Photoshop',
    },
    {
        id: 37,
        label: 'Fichier > Tout fermer',
        placement: 'MenuBar',
        name: 'Tout fermer',
    },
    {
        id: 46,
        label: 'Fichier > Fermer les autres',
        placement: 'MenuBar',
        name: 'Fermer les autres',
    },
    {
        id: 101,
        label: 'Edition > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 103,
        label: 'Edition > Couper',
        placement: 'MenuBar',
        name: 'Couper',
    },
    {
        id: 104,
        label: 'Edition > Copier',
        placement: 'MenuBar',
        name: 'Copier',
    },
    {
        id: 105,
        label: 'Edition > Coller',
        placement: 'MenuBar',
        name: 'Coller',
    },
    {
        id: 106,
        label: 'Edition > Effacer',
        placement: 'MenuBar',
        name: 'Effacer',
    },
    {
        id: 132,
        label: 'Edition > Rétablir',
        placement: 'MenuBar',
        name: 'Rétablir',
    },
    {
        id: 133,
        label: 'Edition > Activer/Désactiver le dernier état',
        placement: 'MenuBar',
        name: 'Activer/Désactiver le dernier état',
    },
    {
        id: 177,
        label: 'Fichier > Imprimer une copie',
        placement: 'MenuBar',
        name: 'Imprimer une copie',
    },
    {
        id: 1001,
        label: 'Fenêtre > Réorganiser > Nouvelle fenêtre',
        placement: 'MenuBar',
        name: 'Nouvelle fenêtre',
    },
    {
        id: 1002,
        label: 'Affichage > Règles',
        placement: 'MenuBar',
        name: 'Règles',
    },
    {
        id: 1004,
        label: 'Affichage > Zoom avant',
        placement: 'MenuBar',
        name: 'Zoom avant',
    },
    {
        id: 1005,
        label: 'Affichage > Zoom arrière',
        placement: 'MenuBar',
        name: 'Zoom arrière',
    },
    {
        id: 1006,
        label: 'Image > Mode > Bitmap',
        placement: 'MenuBar',
        name: 'Bitmap',
    },
    {
        id: 1007,
        label: 'Image > Mode > Niveaux de gris',
        placement: 'MenuBar',
        name: 'Niveaux de gris',
    },
    {
        id: 1008,
        label: 'Image > Mode > Bichromie',
        placement: 'MenuBar',
        name: 'Bichromie',
    },
    {
        id: 1009,
        label: 'Image > Mode > Couleurs indexées',
        placement: 'MenuBar',
        name: 'Couleurs indexées',
    },
    {
        id: 1010,
        label: 'Image > Mode > Couleurs RVB',
        placement: 'MenuBar',
        name: 'Couleurs RVB',
    },
    {
        id: 1011,
        label: 'Image > Mode > Couleurs CMJN',
        placement: 'MenuBar',
        name: 'Couleurs CMJN',
    },
    {
        id: 1014,
        label: 'Image > Mode > Multicouche',
        placement: 'MenuBar',
        name: 'Multicouche',
    },
    {
        id: 1016,
        label: 'Sélection > Désélectionner',
        placement: 'MenuBar',
        name: 'Désélectionner',
    },
    {
        id: 1017,
        label: 'Sélection > Tout sélectionner',
        placement: 'MenuBar',
        name: 'Tout sélectionner',
    },
    {
        id: 1018,
        label: 'Sélection > Intervertir',
        placement: 'MenuBar',
        name: 'Intervertir',
    },
    {
        id: 1019,
        label: 'Filtre > Filtre précédent',
        placement: 'MenuBar',
        name: 'Filtre précédent',
    },
    {
        id: 1021,
        label: 'Fenêtre > Couches',
        placement: 'MenuBar',
        name: 'Couches',
    },
    {
        id: 1025,
        label: 'Fenêtre > Paramètres de pinceau',
        placement: 'MenuBar',
        name: 'Paramètres de pinceau',
    },
    {
        id: 1029,
        label: 'Edition > Définir un pinceau prédéfini...',
        placement: 'MenuBar',
        name: 'Définir un pinceau prédéfini...',
    },
    {
        id: 1030,
        label: "Image > Taille de l'image...",
        placement: 'MenuBar',
        name: "Taille de l'image...",
    },
    {
        id: 1031,
        label: 'Image > Taille de la zone de travail...',
        placement: 'MenuBar',
        name: 'Taille de la zone de travail...',
    },
    {
        id: 1032,
        label: 'Fichier > Importer et incorporer…',
        placement: 'MenuBar',
        name: 'Importer et incorporer…',
    },
    {
        id: 1033,
        label: 'Sélection > Etendre',
        placement: 'MenuBar',
        name: 'Etendre',
    },
    {
        id: 1034,
        label: 'Sélection > Généraliser',
        placement: 'MenuBar',
        name: 'Généraliser',
    },
    {
        id: 1035,
        label: 'Sélection > Modifier > Bordure…',
        placement: 'MenuBar',
        name: 'Bordure…',
    },
    {
        id: 1036,
        label: 'Sélection > Modifier > Contour progressif...',
        placement: 'MenuBar',
        name: 'Contour progressif...',
    },
    {
        id: 1037,
        label: 'Calque > Cache > Supprimer les franges...',
        placement: 'MenuBar',
        name: 'Supprimer les franges...',
    },
    {
        id: 1038,
        label: 'Edition > Utiliser comme motif...',
        placement: 'MenuBar',
        name: 'Utiliser comme motif...',
    },
    {
        id: 1040,
        label: 'Edition > Collage spécial > Coller dedans',
        placement: 'MenuBar',
        name: 'Coller dedans',
    },
    {
        id: 1042,
        label: 'Edition > Remplir...',
        placement: 'MenuBar',
        name: 'Remplir...',
    },
    {
        id: 1043,
        label: 'Edition > Contour...',
        placement: 'MenuBar',
        name: 'Contour...',
    },
    {
        id: 1044,
        label: 'Image > Recadrer',
        placement: 'MenuBar',
        name: 'Recadrer',
    },
    {
        id: 1045,
        label: 'Image > Mode > Table des couleurs...',
        placement: 'MenuBar',
        name: 'Table des couleurs...',
    },
    {
        id: 1046,
        label: 'Fenêtre > Couleur',
        placement: 'MenuBar',
        name: 'Couleur',
    },
    {
        id: 1052,
        label: 'Image > Mode > Couleurs Lab',
        placement: 'MenuBar',
        name: 'Couleurs Lab',
    },
    {
        id: 1055,
        label: 'Fenêtre > Informations',
        placement: 'MenuBar',
        name: 'Informations',
    },
    {
        id: 1058,
        label: 'Fenêtre > Source de duplication',
        placement: 'MenuBar',
        name: 'Source de duplication',
    },
    {
        id: 1065,
        label: 'Fenêtre > Tracés',
        placement: 'MenuBar',
        name: 'Tracés',
    },
    {
        id: 1080,
        label: 'Image > Rognage...',
        placement: 'MenuBar',
        name: 'Rognage...',
    },
    {
        id: 1081,
        label: 'Image > Tout faire apparaître',
        placement: 'MenuBar',
        name: 'Tout faire apparaître',
    },
    {
        id: 1093,
        label: 'Image > Recouvrement...',
        placement: 'MenuBar',
        name: 'Recouvrement...',
    },
    {
        id: 1098,
        label: 'Fenêtre > Calques',
        placement: 'MenuBar',
        name: 'Calques',
    },
    {
        id: 1099,
        label: 'Calque > Nouveau > Calque...',
        placement: 'MenuBar',
        name: 'Calque...',
    },
    {
        id: 1100,
        label: 'Calque > Supprimer > Calque',
        placement: 'MenuBar',
        name: 'Calque',
    },
    {
        id: 1103,
        label: 'Calque > Options de contenu de calque...',
        placement: 'MenuBar',
        name: 'Options de contenu de calque...',
    },
    {
        id: 1105,
        label: "Affichage > Couleurs d'épreuve",
        placement: 'MenuBar',
        name: "Couleurs d'épreuve",
    },
    {
        id: 1106,
        label: 'Affichage > Couleurs non imprimables',
        placement: 'MenuBar',
        name: 'Couleurs non imprimables',
    },
    {
        id: 1107,
        label: 'Edition > Copier avec fusion',
        placement: 'MenuBar',
        name: 'Copier avec fusion',
    },
    {
        id: 1108,
        label: 'Sélection > Modifier > Lisser...',
        placement: 'MenuBar',
        name: 'Lisser...',
    },
    {
        id: 1109,
        label: 'Sélection > Modifier > Dilater...',
        placement: 'MenuBar',
        name: 'Dilater...',
    },
    {
        id: 1110,
        label: 'Sélection > Modifier > Contracter...',
        placement: 'MenuBar',
        name: 'Contracter...',
    },
    {
        id: 1111,
        label: 'Fenêtre > Options',
        placement: 'MenuBar',
        name: 'Options',
    },
    {
        id: 1112,
        label: 'Affichage > Correction du format des pixels',
        placement: 'MenuBar',
        name: 'Correction du format des pixels',
    },
    {
        id: 1114,
        label: 'Calque > Masquer le calque',
        placement: 'MenuBar',
        name: 'Masquer le calque',
    },
    {
        id: 1115,
        label: 'Sélection > Sélectionner et masquer...',
        placement: 'MenuBar',
        name: 'Sélectionner et masquer...',
    },
    {
        id: 1119,
        label: 'Fenêtre > Nuancier',
        placement: 'MenuBar',
        name: 'Nuancier',
    },
    {
        id: 1134,
        label: 'Image > Dupliquer...',
        placement: 'MenuBar',
        name: 'Dupliquer...',
    },
    {
        id: 1135,
        label: 'Calque > Dupliquer le calque...',
        placement: 'MenuBar',
        name: 'Dupliquer le calque...',
    },
    {
        id: 1137,
        label: 'Fichier > Informations...',
        placement: 'MenuBar',
        name: 'Informations...',
    },
    {
        id: 1139,
        label: 'Calque > Fusionner les calques visibles',
        placement: 'MenuBar',
        name: 'Fusionner les calques visibles',
    },
    {
        id: 1141,
        label: "Calque > Aplatir l'image",
        placement: 'MenuBar',
        name: "Aplatir l'image",
    },
    {
        id: 1152,
        label: 'Sélection > Plage de couleurs...',
        placement: 'MenuBar',
        name: 'Plage de couleurs...',
    },
    {
        id: 1153,
        label: 'Image > Appliquer une image...',
        placement: 'MenuBar',
        name: 'Appliquer une image...',
    },
    {
        id: 1154,
        label: 'Edition > Atténuer...',
        placement: 'MenuBar',
        name: 'Atténuer...',
    },
    {
        id: 1156,
        label: 'Calque > Masque de fusion > Tout masquer',
        placement: 'MenuBar',
        name: 'Tout masquer',
    },
    {
        id: 1157,
        label: 'Calque > Masque de fusion > Tout faire apparaître',
        placement: 'MenuBar',
        name: 'Tout faire apparaître',
    },
    {
        id: 1158,
        label: 'Calque > Masque de fusion > Faire apparaître la sélection',
        placement: 'MenuBar',
        name: 'Faire apparaître la sélection',
    },
    {
        id: 1159,
        label: 'Calque > Masque de fusion > Activer',
        placement: 'MenuBar',
        name: 'Activer',
    },
    {
        id: 1161,
        label: 'Image > Mode > 8 bits/couche',
        placement: 'MenuBar',
        name: '8 bits/couche',
    },
    {
        id: 1162,
        label: 'Image > Mode > 16 bits/couche',
        placement: 'MenuBar',
        name: '16 bits/couche',
    },
    {
        id: 1163,
        label: 'Fenêtre > Navigation',
        placement: 'MenuBar',
        name: 'Navigation',
    },
    {
        id: 1166,
        label: 'Calque > Fusionner les calques',
        placement: 'MenuBar',
        name: 'Fusionner les calques',
    },
    {
        id: 1167,
        label: 'Fenêtre > Compositions de calques',
        placement: 'MenuBar',
        name: 'Compositions de calques',
    },
    {
        id: 1168,
        label: 'Calque > Masque de fusion > Masquer la sélection',
        placement: 'MenuBar',
        name: 'Masquer la sélection',
    },
    {
        id: 1169,
        label: 'Fichier > Automatisation > Créer un droplet...',
        placement: 'MenuBar',
        name: 'Créer un droplet...',
    },
    {
        id: 1170,
        label: 'Fenêtre > Actions',
        placement: 'MenuBar',
        name: 'Actions',
    },
    {
        id: 1180,
        label: 'Fichier > Automatisation > Traitement par lots...',
        placement: 'MenuBar',
        name: 'Traitement par lots...',
    },
    {
        id: 1188,
        label: 'Fenêtre > Montage',
        placement: 'MenuBar',
        name: 'Montage',
    },
    {
        id: 1190,
        label: 'Affichage > 100%',
        placement: 'MenuBar',
        name: '100%',
    },
    {
        id: 1191,
        label: "Affichage > Taille d'impression",
        placement: 'MenuBar',
        name: "Taille d'impression",
    },
    {
        id: 1192,
        label: 'Affichage > Taille écran',
        placement: 'MenuBar',
        name: 'Taille écran',
    },
    {
        id: 1194,
        label: 'Fenêtre > Outils',
        placement: 'MenuBar',
        name: 'Outils',
    },
    {
        id: 1195,
        label: "Affichage > Adapter le plan de travail à l'écran",
        placement: 'MenuBar',
        name: "Adapter le plan de travail à l'écran",
    },
    {
        id: 1199,
        label: 'Fenêtre > Historique',
        placement: 'MenuBar',
        name: 'Historique',
    },
    {
        id: 1200,
        label: 'Sélection > Récupérer la sélection...',
        placement: 'MenuBar',
        name: 'Récupérer la sélection...',
    },
    {
        id: 1202,
        label: 'Affichage > Format des pixels > Format des pixels personnalisé...',
        placement: 'MenuBar',
        name: 'Format des pixels personnalisé...',
    },
    {
        id: 1203,
        label: 'Affichage > Format des pixels > Supprimer le format des pixels...',
        placement: 'MenuBar',
        name: 'Supprimer le format des pixels...',
    },
    {
        id: 1204,
        label: 'Affichage > Format des pixels > Réinitialiser le format des pixels...',
        placement: 'MenuBar',
        name: 'Réinitialiser le format des pixels...',
    },
    {
        id: 1205,
        label: 'Affichage > Format des pixels > Carré',
        placement: 'MenuBar',
        name: 'Carré',
    },
    {
        id: 1206,
        label: 'Image > Mode > 32 bits/couche',
        placement: 'MenuBar',
        name: '32 bits/couche',
    },
    {
        id: 1211,
        label: 'Edition > Paramètres prédéfinis > Migrer les paramètres prédéfinis',
        placement: 'MenuBar',
        name: 'Migrer les paramètres prédéfinis',
    },
    {
        id: 1212,
        label: 'Edition > Attribuer un profil...',
        placement: 'MenuBar',
        name: 'Attribuer un profil...',
    },
    {
        id: 1213,
        label: 'Edition > Convertir en profil...',
        placement: 'MenuBar',
        name: 'Convertir en profil...',
    },
    {
        id: 1214,
        label: 'Edition > Paramètres prédéfinis > Gestionnaire des paramètres prédéfinis...',
        placement: 'MenuBar',
        name: 'Gestionnaire des paramètres prédéfinis...',
    },
    {
        id: 1215,
        label: 'Edition > Paramètres prédéfinis Adobe PDF...',
        placement: 'MenuBar',
        name: 'Paramètres prédéfinis Adobe PDF...',
    },
    {
        id: 1217,
        label: 'Affichage > Taille réelle',
        placement: 'MenuBar',
        name: 'Taille réelle',
    },
    {
        id: 1223,
        label: 'Texte > Orientation > Horizontal',
        placement: 'MenuBar',
        name: 'Horizontal',
    },
    {
        id: 1224,
        label: 'Texte > Orientation > Vertical',
        placement: 'MenuBar',
        name: 'Vertical',
    },
    {
        id: 1228,
        label: 'Texte > Créer un tracé de travail',
        placement: 'MenuBar',
        name: 'Créer un tracé de travail',
    },
    {
        id: 1229,
        label: 'Texte > Convertir en forme',
        placement: 'MenuBar',
        name: 'Convertir en forme',
    },
    {
        id: 1231,
        label: 'Calque > Alignement > Bords supérieurs',
        placement: 'MenuBar',
        name: 'Bords supérieurs',
    },
    {
        id: 1232,
        label: 'Calque > Alignement > Bords inférieurs',
        placement: 'MenuBar',
        name: 'Bords inférieurs',
    },
    {
        id: 1233,
        label: 'Calque > Alignement > Centres dans le sens vertical',
        placement: 'MenuBar',
        name: 'Centres dans le sens vertical',
    },
    {
        id: 1234,
        label: 'Calque > Alignement > Bords gauches',
        placement: 'MenuBar',
        name: 'Bords gauches',
    },
    {
        id: 1235,
        label: 'Calque > Alignement > Bords droits',
        placement: 'MenuBar',
        name: 'Bords droits',
    },
    {
        id: 1236,
        label: 'Calque > Alignement > Centres dans le sens horizontal',
        placement: 'MenuBar',
        name: 'Centres dans le sens horizontal',
    },
    {
        id: 1237,
        label: 'Edition > Alignement automatique des calques...',
        placement: 'MenuBar',
        name: 'Alignement automatique des calques...',
    },
    {
        id: 1238,
        label: 'Edition > Fusion automatique des calques...',
        placement: 'MenuBar',
        name: 'Fusion automatique des calques...',
    },
    {
        id: 1239,
        label: 'Calque > Répartition > Verticalement',
        placement: 'MenuBar',
        name: 'Verticalement',
    },
    {
        id: 1241,
        label: 'Calque > Répartition > Bords supérieurs',
        placement: 'MenuBar',
        name: 'Bords supérieurs',
    },
    {
        id: 1242,
        label: 'Calque > Répartition > Bords inférieurs',
        placement: 'MenuBar',
        name: 'Bords inférieurs',
    },
    {
        id: 1243,
        label: 'Calque > Répartition > Centres dans le sens vertical',
        placement: 'MenuBar',
        name: 'Centres dans le sens vertical',
    },
    {
        id: 1245,
        label: 'Calque > Répartition > Bords gauches',
        placement: 'MenuBar',
        name: 'Bords gauches',
    },
    {
        id: 1246,
        label: 'Calque > Répartition > Bords droits',
        placement: 'MenuBar',
        name: 'Bords droits',
    },
    {
        id: 1247,
        label: 'Calque > Répartition > Centres dans le sens horizontal',
        placement: 'MenuBar',
        name: 'Centres dans le sens horizontal',
    },
    {
        id: 1249,
        label: 'Calque > Répartition > Horizontalement',
        placement: 'MenuBar',
        name: 'Horizontalement',
    },
    {
        id: 1281,
        label: 'Sélection > Mémoriser la sélection...',
        placement: 'MenuBar',
        name: 'Mémoriser la sélection...',
    },
    {
        id: 1284,
        label: 'Affichage > Symétrie axe horizontal',
        placement: 'MenuBar',
        name: 'Symétrie axe horizontal',
    },
    {
        id: 1285,
        label: 'Affichage > Aperçu du motif',
        placement: 'MenuBar',
        name: 'Aperçu du motif',
    },
    {
        id: 1292,
        label: 'Calque > Masque de fusion > A partir de la transparence',
        placement: 'MenuBar',
        name: 'A partir de la transparence',
    },
    {
        id: 1295,
        label: 'Calque > Cache > Décontamination chromatique...',
        placement: 'MenuBar',
        name: 'Décontamination chromatique...',
    },
    {
        id: 1297,
        label: 'Edition > Collage spécial > Coller en place',
        placement: 'MenuBar',
        name: 'Coller en place',
    },
    {
        id: 1299,
        label: 'Affichage > 200%',
        placement: 'MenuBar',
        name: '200%',
    },
    {
        id: 1301,
        label: 'Calque > Style de calque > Ombre portée...',
        placement: 'MenuBar',
        name: 'Ombre portée...',
    },
    {
        id: 1302,
        label: 'Calque > Style de calque > Ombre interne...',
        placement: 'MenuBar',
        name: 'Ombre interne...',
    },
    {
        id: 1303,
        label: 'Calque > Style de calque > Lueur externe...',
        placement: 'MenuBar',
        name: 'Lueur externe...',
    },
    {
        id: 1304,
        label: 'Calque > Style de calque > Lueur interne...',
        placement: 'MenuBar',
        name: 'Lueur interne...',
    },
    {
        id: 1305,
        label: 'Calque > Style de calque > Biseautage & estampage...',
        placement: 'MenuBar',
        name: 'Biseautage & estampage...',
    },
    {
        id: 1306,
        label: 'Calque > Style de calque > Masquer tous les effets',
        placement: 'MenuBar',
        name: 'Masquer tous les effets',
    },
    {
        id: 1307,
        label: 'Calque > Style de calque > Eclairage global...',
        placement: 'MenuBar',
        name: 'Eclairage global...',
    },
    {
        id: 1308,
        label: 'Calque > Style de calque > Créer des calques',
        placement: 'MenuBar',
        name: 'Créer des calques',
    },
    {
        id: 1312,
        label: 'Calque > Style de calque > Satin...',
        placement: 'MenuBar',
        name: 'Satin...',
    },
    {
        id: 1313,
        label: 'Calque > Style de calque > Contour...',
        placement: 'MenuBar',
        name: 'Contour...',
    },
    {
        id: 1314,
        label: 'Calque > Style de calque > Copier le style de calque',
        placement: 'MenuBar',
        name: 'Copier le style de calque',
    },
    {
        id: 1315,
        label: 'Calque > Style de calque > Coller le style de calque',
        placement: 'MenuBar',
        name: 'Coller le style de calque',
    },
    {
        id: 1327,
        label: "Calque > Style de calque > Mise à l'échelle des effets...",
        placement: 'MenuBar',
        name: "Mise à l'échelle des effets...",
    },
    {
        id: 1331,
        label: 'Calque > Style de calque > Options de fusion...',
        placement: 'MenuBar',
        name: 'Options de fusion...',
    },
    {
        id: 1335,
        label: 'Calque > Style de calque > Incrustation couleur...',
        placement: 'MenuBar',
        name: 'Incrustation couleur...',
    },
    {
        id: 1336,
        label: 'Calque > Style de calque > Incrustation en dégradé...',
        placement: 'MenuBar',
        name: 'Incrustation en dégradé...',
    },
    {
        id: 1337,
        label: 'Calque > Style de calque > Incrustation de motif...',
        placement: 'MenuBar',
        name: 'Incrustation de motif...',
    },
    {
        id: 1339,
        label: 'Calque > Style de calque > Effacer le style de calque',
        placement: 'MenuBar',
        name: 'Effacer le style de calque',
    },
    {
        id: 1355,
        label: 'Fenêtre > Annotations',
        placement: 'MenuBar',
        name: 'Annotations',
    },
    {
        id: 1382,
        label: 'Fenêtre > Histogramme',
        placement: 'MenuBar',
        name: 'Histogramme',
    },
    {
        id: 1396,
        label: 'Fenêtre > Pinceaux',
        placement: 'MenuBar',
        name: 'Pinceaux',
    },
    {
        id: 1429,
        label: 'Plug-ins > Volet des plug-ins',
        placement: 'MenuBar',
        name: 'Volet des plug-ins',
    },
    {
        id: 1430,
        label: 'Plug-ins > Parcourir les plug-ins...',
        placement: 'MenuBar',
        name: 'Parcourir les plug-ins...',
    },
    {
        id: 1431,
        label: 'Plug-ins > Gérer les plug-ins...',
        placement: 'MenuBar',
        name: 'Gérer les plug-ins...',
    },
    {
        id: 1460,
        label: 'Sélection > Zone de mise au point...',
        placement: 'MenuBar',
        name: 'Zone de mise au point...',
    },
    {
        id: 1461,
        label: 'Sélection > Sujet',
        placement: 'MenuBar',
        name: 'Sujet',
    },
    {
        id: 1462,
        label: 'Sélection > Ciel',
        placement: 'MenuBar',
        name: 'Ciel',
    },
    {
        id: 1502,
        label: 'Fichier > Importation > Images du périphérique...',
        placement: 'MenuBar',
        name: 'Images du périphérique...',
    },
    {
        id: 1503,
        label: 'Fichier > Importer depuis un iPhone ou un iPad',
        placement: 'MenuBar',
        name: 'Importer depuis un iPhone ou un iPad',
    },
    {
        id: 1510,
        label: "Edition > Remplissage d'après le contenu...",
        placement: 'MenuBar',
        name: "Remplissage d'après le contenu...",
    },
    {
        id: 1520,
        label: 'Fichier > Parcourir dans Bridge...',
        placement: 'MenuBar',
        name: 'Parcourir dans Bridge...',
    },
    {
        id: 1522,
        label: 'Texte > Plus sur Adobe Fonts',
        placement: 'MenuBar',
        name: 'Plus sur Adobe Fonts',
    },
    {
        id: 1530,
        label: 'Fichier > Fermer et passer à Bridge...',
        placement: 'MenuBar',
        name: 'Fermer et passer à Bridge...',
    },
    {
        id: 1613,
        label: 'Edition > Connexions à distance...',
        placement: 'MenuBar',
        name: 'Connexions à distance...',
    },
    {
        id: 1676,
        label: 'Fichier > Scripts > Parcourir...',
        placement: 'MenuBar',
        name: 'Parcourir...',
    },
    {
        id: 1695,
        label: 'Fichier > Exportation > Enregistrer pour le Web...',
        placement: 'MenuBar',
        name: 'Enregistrer pour le Web...',
    },
    {
        id: 1696,
        label: 'Fichier > Automatisation > Présentation PDF...',
        placement: 'MenuBar',
        name: 'Présentation PDF...',
    },
    {
        id: 1701,
        label: 'Image > Réglages > Négatif',
        placement: 'MenuBar',
        name: 'Négatif',
    },
    {
        id: 1702,
        label: 'Image > Réglages > Egaliser',
        placement: 'MenuBar',
        name: 'Egaliser',
    },
    {
        id: 1703,
        label: 'Image > Réglages > Seuil...',
        placement: 'MenuBar',
        name: 'Seuil...',
    },
    {
        id: 1704,
        label: 'Image > Réglages > Isohélie...',
        placement: 'MenuBar',
        name: 'Isohélie...',
    },
    {
        id: 1750,
        label: 'Edition > Remplissage génératif...',
        placement: 'MenuBar',
        name: 'Remplissage génératif...',
    },
    {
        id: 1771,
        label: 'Edition > Générer une image...',
        placement: 'MenuBar',
        name: 'Générer une image...',
    },
    {
        id: 1776,
        label: 'Image > Agrandissement génératif...',
        placement: 'MenuBar',
        name: 'Agrandissement génératif...',
    },
    {
        id: 1777,
        label: 'Filtre > Réduction du bruit par l’IA...',
        placement: 'MenuBar',
        name: 'Réduction du bruit par l’IA...',
    },
    {
        id: 1778,
        label: 'Filtre > Accentuer par IA...',
        placement: 'MenuBar',
        name: 'Accentuer par IA...',
    },
    {
        id: 1801,
        label: 'Image > Réglages > Niveaux...',
        placement: 'MenuBar',
        name: 'Niveaux...',
    },
    {
        id: 1802,
        label: 'Image > Réglages > Courbes...',
        placement: 'MenuBar',
        name: 'Courbes...',
    },
    {
        id: 1803,
        label: 'Image > Réglages > Luminosité/Contraste...',
        placement: 'MenuBar',
        name: 'Luminosité/Contraste...',
    },
    {
        id: 1804,
        label: 'Image > Réglages > Balance des couleurs...',
        placement: 'MenuBar',
        name: 'Balance des couleurs...',
    },
    {
        id: 1805,
        label: 'Image > Réglages > Teinte/Saturation...',
        placement: 'MenuBar',
        name: 'Teinte/Saturation...',
    },
    {
        id: 1806,
        label: 'Image > Réglages > Remplacement de couleur...',
        placement: 'MenuBar',
        name: 'Remplacement de couleur...',
    },
    {
        id: 1807,
        label: 'Image > Réglages > Correction sélective...',
        placement: 'MenuBar',
        name: 'Correction sélective...',
    },
    {
        id: 1808,
        label: 'Image > Tonalité automatique',
        placement: 'MenuBar',
        name: 'Tonalité automatique',
    },
    {
        id: 1809,
        label: 'Image > Réglages > Désaturation',
        placement: 'MenuBar',
        name: 'Désaturation',
    },
    {
        id: 1810,
        label: 'Image > Contraste automatique',
        placement: 'MenuBar',
        name: 'Contraste automatique',
    },
    {
        id: 1817,
        label: 'Image > Couleur automatique',
        placement: 'MenuBar',
        name: 'Couleur automatique',
    },
    {
        id: 1822,
        label: 'Image > Réglages > Correspondance de la couleur...',
        placement: 'MenuBar',
        name: 'Correspondance de la couleur...',
    },
    {
        id: 1824,
        label: 'Image > Réglages > Noir et blanc...',
        placement: 'MenuBar',
        name: 'Noir et blanc...',
    },
    {
        id: 1827,
        label: 'Image > Réglages > Vibrance...',
        placement: 'MenuBar',
        name: 'Vibrance...',
    },
    {
        id: 1900,
        label: 'Image > Opérations...',
        placement: 'MenuBar',
        name: 'Opérations...',
    },
    {
        id: 1942,
        label: 'Calque > Nouveau > Arrière-plan',
        placement: 'MenuBar',
        name: 'Arrière-plan',
    },
    {
        id: 1943,
        label: 'Sélection > Resélectionner',
        placement: 'MenuBar',
        name: 'Resélectionner',
    },
    {
        id: 1953,
        label: 'Calque > Masque vectoriel > Tout masquer',
        placement: 'MenuBar',
        name: 'Tout masquer',
    },
    {
        id: 1954,
        label: 'Calque > Masque vectoriel > Tout faire apparaître',
        placement: 'MenuBar',
        name: 'Tout faire apparaître',
    },
    {
        id: 1955,
        label: 'Calque > Masque vectoriel > Tracé sélectionné',
        placement: 'MenuBar',
        name: 'Tracé sélectionné',
    },
    {
        id: 1956,
        label: 'Calque > Masque vectoriel > Supprimer',
        placement: 'MenuBar',
        name: 'Supprimer',
    },
    {
        id: 1957,
        label: 'Calque > Pixellisation > Masque vectoriel',
        placement: 'MenuBar',
        name: 'Masque vectoriel',
    },
    {
        id: 1959,
        label: 'Calque > Masque vectoriel > Activer',
        placement: 'MenuBar',
        name: 'Activer',
    },
    {
        id: 1971,
        label: 'Sélection > Transformer la sélection',
        placement: 'MenuBar',
        name: 'Transformer la sélection',
    },
    {
        id: 2101,
        label: 'Fichier > Imprimer...',
        placement: 'MenuBar',
        name: 'Imprimer...',
    },
    {
        id: 2103,
        label: 'Fichier > Ouvrir les fichiers récents > Effacer la liste des fichiers récents',
        placement: 'MenuBar',
        name: 'Effacer la liste des fichiers récents',
    },
    {
        id: 2109,
        label: 'Calque > Masque vectoriel > Lier',
        placement: 'MenuBar',
        name: 'Lier',
    },
    {
        id: 2201,
        label: 'Edition > Transformation > Homothétie',
        placement: 'MenuBar',
        name: 'Homothétie',
    },
    {
        id: 2202,
        label: 'Edition > Transformation > Inclinaison',
        placement: 'MenuBar',
        name: 'Inclinaison',
    },
    {
        id: 2203,
        label: 'Edition > Transformation > Perspective',
        placement: 'MenuBar',
        name: 'Perspective',
    },
    {
        id: 2204,
        label: 'Edition > Transformation > Distorsion',
        placement: 'MenuBar',
        name: 'Distorsion',
    },
    {
        id: 2205,
        label: 'Edition > Transformation > Rotation',
        placement: 'MenuBar',
        name: 'Rotation',
    },
    {
        id: 2207,
        label: 'Edition > Transformation manuelle',
        placement: 'MenuBar',
        name: 'Transformation manuelle',
    },
    {
        id: 2208,
        label: 'Edition > Transformation > Rotation 180°',
        placement: 'MenuBar',
        name: 'Rotation 180°',
    },
    {
        id: 2209,
        label: 'Edition > Transformation > Rotation horaire de 90°',
        placement: 'MenuBar',
        name: 'Rotation horaire de 90°',
    },
    {
        id: 2210,
        label: 'Edition > Transformation > Rotation antihoraire de 90°',
        placement: 'MenuBar',
        name: 'Rotation antihoraire de 90°',
    },
    {
        id: 2211,
        label: 'Edition > Transformation > Symétrie axe horizontal',
        placement: 'MenuBar',
        name: 'Symétrie axe horizontal',
    },
    {
        id: 2212,
        label: 'Edition > Transformation > Symétrie axe vertical',
        placement: 'MenuBar',
        name: 'Symétrie axe vertical',
    },
    {
        id: 2217,
        label: 'Edition > Transformation > Répéter',
        placement: 'MenuBar',
        name: 'Répéter',
    },
    {
        id: 2218,
        label: 'Texte > Déformer le texte...',
        placement: 'MenuBar',
        name: 'Déformer le texte...',
    },
    {
        id: 2219,
        label: 'Edition > Transformation > Déformation',
        placement: 'MenuBar',
        name: 'Déformation',
    },
    {
        id: 2220,
        label: 'Edition > Echelle basée sur le contenu',
        placement: 'MenuBar',
        name: 'Echelle basée sur le contenu',
    },
    {
        id: 2221,
        label: 'Edition > Déformation de la marionnette',
        placement: 'MenuBar',
        name: 'Déformation de la marionnette',
    },
    {
        id: 2224,
        label: "Filtre > Galerie d'effets de flou > Flou de diaphragme...",
        placement: 'MenuBar',
        name: 'Flou de diaphragme...',
    },
    {
        id: 2225,
        label: "Filtre > Galerie d'effets de flou > Flou de profondeur de champ...",
        placement: 'MenuBar',
        name: 'Flou de profondeur de champ...',
    },
    {
        id: 2226,
        label: "Filtre > Galerie d'effets de flou > Bascule-Décentrement...",
        placement: 'MenuBar',
        name: 'Bascule-Décentrement...',
    },
    {
        id: 2227,
        label: "Filtre > Galerie d'effets de flou > Flou de tracé...",
        placement: 'MenuBar',
        name: 'Flou de tracé...',
    },
    {
        id: 2229,
        label: "Filtre > Galerie d'effets de flou > Flou de rotation…",
        placement: 'MenuBar',
        name: 'Flou de rotation…',
    },
    {
        id: 2231,
        label: 'Filtre > Rendu > Flamme...',
        placement: 'MenuBar',
        name: 'Flamme...',
    },
    {
        id: 2232,
        label: "Filtre > Rendu > Cadre d'image...",
        placement: 'MenuBar',
        name: "Cadre d'image...",
    },
    {
        id: 2233,
        label: 'Filtre > Rendu > Arbre...',
        placement: 'MenuBar',
        name: 'Arbre...',
    },
    {
        id: 2250,
        label: "Edition > Transformation > Fractionner la déformation à l'horizontale",
        placement: 'MenuBar',
        name: "Fractionner la déformation à l'horizontale",
    },
    {
        id: 2251,
        label: 'Edition > Transformation > Fractionner la déformation à la verticale',
        placement: 'MenuBar',
        name: 'Fractionner la déformation à la verticale',
    },
    {
        id: 2252,
        label: 'Edition > Transformation > Fractionner la déformation en travers',
        placement: 'MenuBar',
        name: 'Fractionner la déformation en travers',
    },
    {
        id: 2253,
        label: 'Edition > Transformation > Retirer le fractionnement de la déformation',
        placement: 'MenuBar',
        name: 'Retirer le fractionnement de la déformation',
    },
    {
        id: 2254,
        label: 'Edition > Transformation > Active/désactive les repères',
        placement: 'MenuBar',
        name: 'Active/désactive les repères',
    },
    {
        id: 2255,
        label: "Edition > Transformation > Convertir le point d'ancrage de la déformation",
        placement: 'MenuBar',
        name: "Convertir le point d'ancrage de la déformation",
    },
    {
        id: 2260,
        label: 'Edition > Remplacement du ciel...',
        placement: 'MenuBar',
        name: 'Remplacement du ciel...',
    },
    {
        id: 2304,
        label: 'Photoshop > Préférences > Performance...',
        placement: 'MenuBar',
        name: 'Performance...',
    },
    {
        id: 2311,
        label: 'Photoshop > Préférences > Général...',
        placement: 'MenuBar',
        name: 'Général...',
    },
    {
        id: 2312,
        label: 'Photoshop > Préférences > Curseurs...',
        placement: 'MenuBar',
        name: 'Curseurs...',
    },
    {
        id: 2313,
        label: 'Photoshop > Préférences > Transparence et couleurs non imprimables...',
        placement: 'MenuBar',
        name: 'Transparence et couleurs non imprimables...',
    },
    {
        id: 2314,
        label: 'Photoshop > Préférences > Unités et règles...',
        placement: 'MenuBar',
        name: 'Unités et règles...',
    },
    {
        id: 2315,
        label: 'Photoshop > Préférences > Repères, grille et tranches...',
        placement: 'MenuBar',
        name: 'Repères, grille et tranches...',
    },
    {
        id: 2316,
        label: 'Photoshop > Préférences > Plug-ins...',
        placement: 'MenuBar',
        name: 'Plug-ins...',
    },
    {
        id: 2317,
        label: 'Photoshop > Préférences > Gestion des fichiers...',
        placement: 'MenuBar',
        name: 'Gestion des fichiers...',
    },
    {
        id: 2322,
        label: 'Photoshop > Préférences > Texte...',
        placement: 'MenuBar',
        name: 'Texte...',
    },
    {
        id: 2323,
        label: 'Photoshop > Préférences > Interface...',
        placement: 'MenuBar',
        name: 'Interface...',
    },
    {
        id: 2324,
        label: 'Photoshop > Préférences > Camera Raw...',
        placement: 'MenuBar',
        name: 'Camera Raw...',
    },
    {
        id: 2327,
        label: 'Photoshop > Préférences > Aperçus de technologie...',
        placement: 'MenuBar',
        name: 'Aperçus de technologie...',
    },
    {
        id: 2328,
        label: 'Photoshop > Préférences > Disques de travail...',
        placement: 'MenuBar',
        name: 'Disques de travail...',
    },
    {
        id: 2329,
        label: 'Photoshop > Préférences > Historique…',
        placement: 'MenuBar',
        name: 'Historique…',
    },
    {
        id: 2330,
        label: 'Photoshop > Préférences > Outils...',
        placement: 'MenuBar',
        name: 'Outils...',
    },
    {
        id: 2331,
        label: 'Photoshop > Préférences > Espace de travail...',
        placement: 'MenuBar',
        name: 'Espace de travail...',
    },
    {
        id: 2332,
        label: 'Photoshop > Préférences > Exporter...',
        placement: 'MenuBar',
        name: 'Exporter...',
    },
    {
        id: 2332,
        label: "Fichier > Exportation > Préférences d'exportation...",
        placement: 'MenuBar',
        name: "Préférences d'exportation...",
    },
    {
        id: 2333,
        label: 'Photoshop > Préférences > Options améliorées…',
        placement: 'MenuBar',
        name: 'Options améliorées…',
    },
    {
        id: 2334,
        label: 'Photoshop > Préférences > Amélioration du produit...',
        placement: 'MenuBar',
        name: 'Amélioration du produit...',
    },
    {
        id: 2335,
        label: "Photoshop > Préférences > Traitement de l'image...",
        placement: 'MenuBar',
        name: "Traitement de l'image...",
    },
    {
        id: 2337,
        label: 'Photoshop > Préférences > Notifications...',
        placement: 'MenuBar',
        name: 'Notifications...',
    },
    {
        id: 2344,
        label: 'Edition > Couleurs...',
        placement: 'MenuBar',
        name: 'Couleurs...',
    },
    {
        id: 2345,
        label: 'Edition > Paramètres OpenColorIO...',
        placement: 'MenuBar',
        name: 'Paramètres OpenColorIO...',
    },
    {
        id: 2361,
        label: 'Edition > Purger > Historique',
        placement: 'MenuBar',
        name: 'Historique',
    },
    {
        id: 2701,
        label: 'Calque > Cache > Retirer le cache noir',
        placement: 'MenuBar',
        name: 'Retirer le cache noir',
    },
    {
        id: 2703,
        label: 'Calque > Cache > Retirer le cache blanc',
        placement: 'MenuBar',
        name: 'Retirer le cache blanc',
    },
    {
        id: 2711,
        label: 'Calque > Disposition > Premier plan',
        placement: 'MenuBar',
        name: 'Premier plan',
    },
    {
        id: 2712,
        label: 'Calque > Disposition > En avant',
        placement: 'MenuBar',
        name: 'En avant',
    },
    {
        id: 2713,
        label: 'Calque > Disposition > En arrière',
        placement: 'MenuBar',
        name: 'En arrière',
    },
    {
        id: 2714,
        label: 'Calque > Disposition > Arrière-plan',
        placement: 'MenuBar',
        name: 'Arrière-plan',
    },
    {
        id: 2715,
        label: 'Calque > Disposition > Inverser',
        placement: 'MenuBar',
        name: 'Inverser',
    },
    {
        id: 2769,
        label: 'Calque > Filtre dynamique > Désactiver les filtres dynamiques',
        placement: 'MenuBar',
        name: 'Désactiver les filtres dynamiques',
    },
    {
        id: 2770,
        label: 'Calque > Filtre dynamique > Effacer les filtres dynamiques',
        placement: 'MenuBar',
        name: 'Effacer les filtres dynamiques',
    },
    {
        id: 2802,
        label: "Affichage > Format d'épreuve > Personnalisé...",
        placement: 'MenuBar',
        name: 'Personnalisé...',
    },
    {
        id: 2803,
        label: "Affichage > Format d'épreuve > Espace de travail CMJN",
        placement: 'MenuBar',
        name: 'Espace de travail CMJN',
    },
    {
        id: 2804,
        label: "Affichage > Format d'épreuve > Plaque de travail Cyan",
        placement: 'MenuBar',
        name: 'Plaque de travail Cyan',
    },
    {
        id: 2805,
        label: "Affichage > Format d'épreuve > Plaque de travail Magenta",
        placement: 'MenuBar',
        name: 'Plaque de travail Magenta',
    },
    {
        id: 2806,
        label: "Affichage > Format d'épreuve > Plaque de travail Jaune",
        placement: 'MenuBar',
        name: 'Plaque de travail Jaune',
    },
    {
        id: 2807,
        label: "Affichage > Format d'épreuve > Plaque de travail Noir",
        placement: 'MenuBar',
        name: 'Plaque de travail Noir',
    },
    {
        id: 2808,
        label: "Affichage > Format d'épreuve > Plaques de travail CMJ",
        placement: 'MenuBar',
        name: 'Plaques de travail CMJ',
    },
    {
        id: 2809,
        label: "Affichage > Format d'épreuve > RVB Macintosh hérité (Gamma 1.8)",
        placement: 'MenuBar',
        name: 'RVB Macintosh hérité (Gamma 1.8)',
    },
    {
        id: 2810,
        label: "Affichage > Format d'épreuve > RVB Internet standard (sRGB)",
        placement: 'MenuBar',
        name: 'RVB Internet standard (sRGB)',
    },
    {
        id: 2811,
        label: "Affichage > Format d'épreuve > RVB Moniteur",
        placement: 'MenuBar',
        name: 'RVB Moniteur',
    },
    {
        id: 2815,
        label: "Affichage > Format d'épreuve > Dyschromatopsie - Protanopie",
        placement: 'MenuBar',
        name: 'Dyschromatopsie - Protanopie',
    },
    {
        id: 2816,
        label: "Affichage > Format d'épreuve > Dyschromatopsie - Deutéranopie",
        placement: 'MenuBar',
        name: 'Dyschromatopsie - Deutéranopie',
    },
    {
        id: 2820,
        label: 'Image > Analyse > Outil Règle',
        placement: 'MenuBar',
        name: 'Outil Règle',
    },
    {
        id: 2830,
        label: "Image > Analyse > Placer un marqueur d'échelle...",
        placement: 'MenuBar',
        name: "Placer un marqueur d'échelle...",
    },
    {
        id: 2841,
        label: "Image > Analyse > Définir l'échelle de mesure > Par défaut",
        placement: 'MenuBar',
        name: 'Par défaut',
    },
    {
        id: 2842,
        label: "Image > Analyse > Définir l'échelle de mesure > Personnalisée...",
        placement: 'MenuBar',
        name: 'Personnalisée...',
    },
    {
        id: 2851,
        label: 'Image > Analyse > Sélectionner des points de données > Personnalisés...',
        placement: 'MenuBar',
        name: 'Personnalisés...',
    },
    {
        id: 2860,
        label: 'Image > Analyse > Enregistrer les mesures',
        placement: 'MenuBar',
        name: 'Enregistrer les mesures',
    },
    {
        id: 2880,
        label: 'Fenêtre > Journal des mesures',
        placement: 'MenuBar',
        name: 'Journal des mesures',
    },
    {
        id: 2912,
        label: 'Edition > Purger > Presse-papiers',
        placement: 'MenuBar',
        name: 'Presse-papiers',
    },
    {
        id: 2915,
        label: 'Edition > Purger > Tout',
        placement: 'MenuBar',
        name: 'Tout',
    },
    {
        id: 2920,
        label: 'Edition > Purger > Cache vidéo',
        placement: 'MenuBar',
        name: 'Cache vidéo',
    },
    {
        id: 2939,
        label: "Fenêtre > Espace de travail > Verrouiller l'espace de travail",
        placement: 'MenuBar',
        name: "Verrouiller l'espace de travail",
    },
    {
        id: 2940,
        label: 'Affichage > Repères > Verrouiller les repères',
        placement: 'MenuBar',
        name: 'Verrouiller les repères',
    },
    {
        id: 2950,
        label: 'Affichage > Repères > Effacer les repères',
        placement: 'MenuBar',
        name: 'Effacer les repères',
    },
    {
        id: 2951,
        label: 'Calque > Supprimer > Calques masqués',
        placement: 'MenuBar',
        name: 'Calques masqués',
    },
    {
        id: 2952,
        label: 'Affichage > Repères > Effacer les repères du plan de travail sélectionné',
        placement: 'MenuBar',
        name: 'Effacer les repères du plan de travail sélectionné',
    },
    {
        id: 2953,
        label: 'Affichage > Repères > Effacer les repères de la zone de travail',
        placement: 'MenuBar',
        name: 'Effacer les repères de la zone de travail',
    },
    {
        id: 2956,
        label: "Calque > Nouveau > Groupe d'après les calques...",
        placement: 'MenuBar',
        name: "Groupe d'après les calques...",
    },
    {
        id: 2957,
        label: 'Calque > Verrouiller les calques...',
        placement: 'MenuBar',
        name: 'Verrouiller les calques...',
    },
    {
        id: 2958,
        label: 'Calque > Associer les calques',
        placement: 'MenuBar',
        name: 'Associer les calques',
    },
    {
        id: 2959,
        label: 'Calque > Dissocier les calques',
        placement: 'MenuBar',
        name: 'Dissocier les calques',
    },
    {
        id: 2960,
        label: 'Calque > Sélectionner les calques liés',
        placement: 'MenuBar',
        name: 'Sélectionner les calques liés',
    },
    {
        id: 2961,
        label: 'Calque > Lier les calques',
        placement: 'MenuBar',
        name: 'Lier les calques',
    },
    {
        id: 2962,
        label: 'Sélection > Tous les calques',
        placement: 'MenuBar',
        name: 'Tous les calques',
    },
    {
        id: 2963,
        label: 'Sélection > Désélectionner les calques',
        placement: 'MenuBar',
        name: 'Désélectionner les calques',
    },
    {
        id: 2967,
        label: 'Affichage > Verrouiller les tranches',
        placement: 'MenuBar',
        name: 'Verrouiller les tranches',
    },
    {
        id: 2969,
        label: 'Affichage > Effacer les tranches',
        placement: 'MenuBar',
        name: 'Effacer les tranches',
    },
    {
        id: 2970,
        label: 'Calque > Nouveau > Calque par Copier',
        placement: 'MenuBar',
        name: 'Calque par Copier',
    },
    {
        id: 2971,
        label: 'Calque > Nouveau > Calque par Couper',
        placement: 'MenuBar',
        name: 'Calque par Couper',
    },
    {
        id: 2972,
        label: "Calque > Créer un masque d'écrêtage",
        placement: 'MenuBar',
        name: "Créer un masque d'écrêtage",
    },
    {
        id: 2976,
        label: 'Calque > Nouveau > Groupe...',
        placement: 'MenuBar',
        name: 'Groupe...',
    },
    {
        id: 2980,
        label: 'Calque > Objets dynamiques > Convertir en objet dynamique',
        placement: 'MenuBar',
        name: 'Convertir en objet dynamique',
    },
    {
        id: 2981,
        label: 'Calque > Objets dynamiques > Nouvel objet dynamique par Copier',
        placement: 'MenuBar',
        name: 'Nouvel objet dynamique par Copier',
    },
    {
        id: 2982,
        label: 'Sélection > Rechercher des calques',
        placement: 'MenuBar',
        name: 'Rechercher des calques',
    },
    {
        id: 2983,
        label: 'Calque > Renommer le calque...',
        placement: 'MenuBar',
        name: 'Renommer le calque...',
    },
    {
        id: 2986,
        label: 'Sélection > Isoler les calques',
        placement: 'MenuBar',
        name: 'Isoler les calques',
    },
    {
        id: 2991,
        label: "Image > Rotation de l'image > Rotation horaire de 90°",
        placement: 'MenuBar',
        name: 'Rotation horaire de 90°',
    },
    {
        id: 2992,
        label: "Image > Rotation de l'image > Rotation antihoraire de 90°",
        placement: 'MenuBar',
        name: 'Rotation antihoraire de 90°',
    },
    {
        id: 2993,
        label: "Image > Rotation de l'image > 180°",
        placement: 'MenuBar',
        name: '180°',
    },
    {
        id: 2994,
        label: "Image > Rotation de l'image > Paramétrée...",
        placement: 'MenuBar',
        name: 'Paramétrée...',
    },
    {
        id: 2996,
        label: "Image > Rotation de l'image > Symétrie horizontale de la zone de travail",
        placement: 'MenuBar',
        name: 'Symétrie horizontale de la zone de travail',
    },
    {
        id: 2997,
        label: "Image > Rotation de l'image > Symétrie verticale de la zone de travail",
        placement: 'MenuBar',
        name: 'Symétrie verticale de la zone de travail',
    },
    {
        id: 3056,
        label: 'Image > Réglages > Mélangeur de couches...',
        placement: 'MenuBar',
        name: 'Mélangeur de couches...',
    },
    {
        id: 3062,
        label: 'Image > Réglages > Courbe de transfert de dégradé...',
        placement: 'MenuBar',
        name: 'Courbe de transfert de dégradé...',
    },
    {
        id: 3063,
        label: 'Image > Réglages > Filtre photo...',
        placement: 'MenuBar',
        name: 'Filtre photo...',
    },
    {
        id: 3065,
        label: 'Image > Réglages > Tons foncés/Tons clairs...',
        placement: 'MenuBar',
        name: 'Tons foncés/Tons clairs...',
    },
    {
        id: 3066,
        label: 'Image > Réglages > Correspondance de couleur...',
        placement: 'MenuBar',
        name: 'Correspondance de couleur...',
    },
    {
        id: 3067,
        label: 'Image > Réglages > Exposition...',
        placement: 'MenuBar',
        name: 'Exposition...',
    },
    {
        id: 3076,
        label: 'Calque > Filtre dynamique > Désactiver le masque filtrant',
        placement: 'MenuBar',
        name: 'Désactiver le masque filtrant',
    },
    {
        id: 3083,
        label: 'Calque > Nouveau calque de réglage > Exposition...',
        placement: 'MenuBar',
        name: 'Exposition...',
    },
    {
        id: 3085,
        label: 'Calque > Nouveau calque de réglage > Couleur et vibrance...',
        placement: 'MenuBar',
        name: 'Couleur et vibrance...',
    },
    {
        id: 3090,
        label: 'Fichier > Importer et lier...',
        placement: 'MenuBar',
        name: 'Importer et lier...',
    },
    {
        id: 3091,
        label: 'Calque > Objets dynamiques > Faire apparaître dans le Finder',
        placement: 'MenuBar',
        name: 'Faire apparaître dans le Finder',
    },
    {
        id: 3092,
        label: 'Fichier > Assemblage...',
        placement: 'MenuBar',
        name: 'Assemblage...',
    },
    {
        id: 3098,
        label: 'Fichier > Automatisation > Plug-ins générateurs',
        placement: 'MenuBar',
        name: 'Plug-ins générateurs',
    },
    {
        id: 3187,
        label: 'Fenêtre > Styles',
        placement: 'MenuBar',
        name: 'Styles',
    },
    {
        id: 3300,
        label: 'Texte > Panneaux > Panneau Caractère',
        placement: 'MenuBar',
        name: 'Panneau Caractère',
    },
    {
        id: 3300,
        label: 'Fenêtre > Caractère',
        placement: 'MenuBar',
        name: 'Caractère',
    },
    {
        id: 3309,
        label: 'Texte > OpenType > Ligatures standard',
        placement: 'MenuBar',
        name: 'Ligatures standard',
    },
    {
        id: 3310,
        label: 'Texte > OpenType > Chiffres elzéviriens',
        placement: 'MenuBar',
        name: 'Chiffres elzéviriens',
    },
    {
        id: 3327,
        label: 'Texte > OpenType > Métrique proportionnelle',
        placement: 'MenuBar',
        name: 'Métrique proportionnelle',
    },
    {
        id: 3334,
        label: 'Texte > OpenType > Lettre italique ornée',
        placement: 'MenuBar',
        name: 'Lettre italique ornée',
    },
    {
        id: 3338,
        label: 'Texte > OpenType > Variantes contextuelles',
        placement: 'MenuBar',
        name: 'Variantes contextuelles',
    },
    {
        id: 3339,
        label: 'Texte > OpenType > Ligatures conditionnelles',
        placement: 'MenuBar',
        name: 'Ligatures conditionnelles',
    },
    {
        id: 3340,
        label: 'Texte > OpenType > Variantes stylistiques',
        placement: 'MenuBar',
        name: 'Variantes stylistiques',
    },
    {
        id: 3341,
        label: 'Texte > OpenType > Variantes de titrage',
        placement: 'MenuBar',
        name: 'Variantes de titrage',
    },
    {
        id: 3342,
        label: 'Texte > OpenType > Ornements',
        placement: 'MenuBar',
        name: 'Ornements',
    },
    {
        id: 3343,
        label: 'Texte > OpenType > Ordinaux',
        placement: 'MenuBar',
        name: 'Ordinaux',
    },
    {
        id: 3344,
        label: 'Texte > OpenType > Fractions',
        placement: 'MenuBar',
        name: 'Fractions',
    },
    {
        id: 3345,
        label: 'Texte > OpenType > Japonais 78',
        placement: 'MenuBar',
        name: 'Japonais 78',
    },
    {
        id: 3346,
        label: 'Texte > OpenType > Japonais Expert',
        placement: 'MenuBar',
        name: 'Japonais Expert',
    },
    {
        id: 3347,
        label: 'Texte > OpenType > Japonais Traditionnel',
        placement: 'MenuBar',
        name: 'Japonais Traditionnel',
    },
    {
        id: 3348,
        label: 'Texte > OpenType > Kana',
        placement: 'MenuBar',
        name: 'Kana',
    },
    {
        id: 3349,
        label: 'Texte > OpenType > Italique romain',
        placement: 'MenuBar',
        name: 'Italique romain',
    },
    {
        id: 3350,
        label: 'Texte > Panneaux > Panneau Paragraphe',
        placement: 'MenuBar',
        name: 'Panneau Paragraphe',
    },
    {
        id: 3350,
        label: 'Fenêtre > Paragraphe',
        placement: 'MenuBar',
        name: 'Paragraphe',
    },
    {
        id: 3370,
        label: 'Texte > Lissage > Sans',
        placement: 'MenuBar',
        name: 'Sans',
    },
    {
        id: 3371,
        label: 'Texte > Lissage > Précise',
        placement: 'MenuBar',
        name: 'Précise',
    },
    {
        id: 3372,
        label: 'Texte > Lissage > Forte',
        placement: 'MenuBar',
        name: 'Forte',
    },
    {
        id: 3373,
        label: 'Texte > Lissage > Légère',
        placement: 'MenuBar',
        name: 'Légère',
    },
    {
        id: 3374,
        label: 'Texte > Lissage > Nette',
        placement: 'MenuBar',
        name: 'Nette',
    },
    {
        id: 3375,
        label: 'Texte > Lissage > LCD Mac',
        placement: 'MenuBar',
        name: 'LCD Mac',
    },
    {
        id: 3376,
        label: 'Texte > Lissage > Mac',
        placement: 'MenuBar',
        name: 'Mac',
    },
    {
        id: 3382,
        label: 'Texte > Convertir le type de forme du texte',
        placement: 'MenuBar',
        name: 'Convertir le type de forme du texte',
    },
    {
        id: 3390,
        label: 'Texte > Mettre à jour tous les calques de texte',
        placement: 'MenuBar',
        name: 'Mettre à jour tous les calques de texte',
    },
    {
        id: 3392,
        label: 'Edition > Orthographe...',
        placement: 'MenuBar',
        name: 'Orthographe...',
    },
    {
        id: 3393,
        label: 'Edition > Rechercher et remplacer du texte...',
        placement: 'MenuBar',
        name: 'Rechercher et remplacer du texte...',
    },
    {
        id: 3409,
        label: 'Calque > Associer des formes > Unir les formes',
        placement: 'MenuBar',
        name: 'Unir les formes',
    },
    {
        id: 3410,
        label: 'Calque > Associer des formes > Soustraire la forme avant',
        placement: 'MenuBar',
        name: 'Soustraire la forme avant',
    },
    {
        id: 3411,
        label: 'Calque > Associer des formes > Unir les formes au chevauchement',
        placement: 'MenuBar',
        name: 'Unir les formes au chevauchement',
    },
    {
        id: 3412,
        label: 'Calque > Associer des formes > Soustraire les formes au chevauchement',
        placement: 'MenuBar',
        name: 'Soustraire les formes au chevauchement',
    },
    {
        id: 3438,
        label: 'Calque > Copier SVG',
        placement: 'MenuBar',
        name: 'Copier SVG',
    },
    {
        id: 3439,
        label: 'Calque > Copier CSS',
        placement: 'MenuBar',
        name: 'Copier CSS',
    },
    {
        id: 3443,
        label: 'Fichier > Exportation > Exporter sous...',
        placement: 'MenuBar',
        name: 'Exporter sous...',
    },
    {
        id: 3444,
        label: 'Fichier > Exportation > Exportation rapide au format PNG',
        placement: 'MenuBar',
        name: 'Exportation rapide au format PNG',
    },
    {
        id: 3446,
        label: 'Calque > Exportation rapide au format PNG',
        placement: 'MenuBar',
        name: 'Exportation rapide au format PNG',
    },
    {
        id: 3447,
        label: 'Calque > Exporter sous...',
        placement: 'MenuBar',
        name: 'Exporter sous...',
    },
    {
        id: 3451,
        label: 'Texte > Options de langue > Chiffres arabes gauche à droite - 123%',
        placement: 'MenuBar',
        name: 'Chiffres arabes gauche à droite - 123%',
    },
    {
        id: 3452,
        label: 'Texte > Options de langue > Chiffres Farsi',
        placement: 'MenuBar',
        name: 'Chiffres Farsi',
    },
    {
        id: 3453,
        label: 'Texte > Options de langue > Chiffres Hindi',
        placement: 'MenuBar',
        name: 'Chiffres Hindi',
    },
    {
        id: 3459,
        label: 'Texte > Options de langue > Chiffres arabes droite à gauche - %123',
        placement: 'MenuBar',
        name: 'Chiffres arabes droite à gauche - %123',
    },
    {
        id: 3500,
        label: 'Affichage > Extras',
        placement: 'MenuBar',
        name: 'Extras',
    },
    {
        id: 3501,
        label: 'Affichage > Afficher > Contour de la sélection',
        placement: 'MenuBar',
        name: 'Contour de la sélection',
    },
    {
        id: 3502,
        label: 'Affichage > Afficher > Tracé cible',
        placement: 'MenuBar',
        name: 'Tracé cible',
    },
    {
        id: 3503,
        label: 'Affichage > Afficher > Repères',
        placement: 'MenuBar',
        name: 'Repères',
    },
    {
        id: 3504,
        label: 'Affichage > Afficher > Grille',
        placement: 'MenuBar',
        name: 'Grille',
    },
    {
        id: 3505,
        label: 'Affichage > Afficher > Tranches',
        placement: 'MenuBar',
        name: 'Tranches',
    },
    {
        id: 3506,
        label: 'Affichage > Afficher > Annotations',
        placement: 'MenuBar',
        name: 'Annotations',
    },
    {
        id: 3507,
        label: 'Affichage > Afficher > Tout',
        placement: 'MenuBar',
        name: 'Tout',
    },
    {
        id: 3508,
        label: 'Affichage > Afficher > Rien',
        placement: 'MenuBar',
        name: 'Rien',
    },
    {
        id: 3510,
        label: 'Affichage > Afficher > Afficher les options des extras...',
        placement: 'MenuBar',
        name: 'Afficher les options des extras...',
    },
    {
        id: 3511,
        label: 'Affichage > Afficher > Repères commentés',
        placement: 'MenuBar',
        name: 'Repères commentés',
    },
    {
        id: 3512,
        label: 'Affichage > Afficher > Contours du calque',
        placement: 'MenuBar',
        name: 'Contours du calque',
    },
    {
        id: 3513,
        label: 'Affichage > Afficher > Comptage',
        placement: 'MenuBar',
        name: 'Comptage',
    },
    {
        id: 3514,
        label: 'Affichage > Afficher > Grille des pixels',
        placement: 'MenuBar',
        name: 'Grille des pixels',
    },
    {
        id: 3517,
        label: 'Affichage > Afficher > Filet',
        placement: 'MenuBar',
        name: 'Filet',
    },
    {
        id: 3520,
        label: 'Affichage > Magnétisme',
        placement: 'MenuBar',
        name: 'Magnétisme',
    },
    {
        id: 3521,
        label: 'Affichage > Accrocher à > Repères',
        placement: 'MenuBar',
        name: 'Repères',
    },
    {
        id: 3522,
        label: 'Affichage > Accrocher à > Grille',
        placement: 'MenuBar',
        name: 'Grille',
    },
    {
        id: 3523,
        label: 'Affichage > Accrocher à > Tranches',
        placement: 'MenuBar',
        name: 'Tranches',
    },
    {
        id: 3524,
        label: 'Affichage > Accrocher à > Limites du document',
        placement: 'MenuBar',
        name: 'Limites du document',
    },
    {
        id: 3527,
        label: 'Affichage > Accrocher à > Tout',
        placement: 'MenuBar',
        name: 'Tout',
    },
    {
        id: 3528,
        label: 'Affichage > Accrocher à > Sans',
        placement: 'MenuBar',
        name: 'Sans',
    },
    {
        id: 3530,
        label: 'Affichage > Accrocher à > Calques',
        placement: 'MenuBar',
        name: 'Calques',
    },
    {
        id: 3532,
        label: 'Affichage > Afficher > Limites du carreau Aperçu du motif',
        placement: 'MenuBar',
        name: 'Limites du carreau Aperçu du motif',
    },
    {
        id: 3533,
        label: 'Affichage > Afficher > Repères du plan de travail',
        placement: 'MenuBar',
        name: 'Repères du plan de travail',
    },
    {
        id: 3535,
        label: 'Affichage > Afficher > Noms des plans de travail',
        placement: 'MenuBar',
        name: 'Noms des plans de travail',
    },
    {
        id: 3536,
        label: 'Affichage > Afficher > Repères de la zone de travail',
        placement: 'MenuBar',
        name: 'Repères de la zone de travail',
    },
    {
        id: 3541,
        label: 'Calque > Pixellisation > Forme',
        placement: 'MenuBar',
        name: 'Forme',
    },
    {
        id: 3542,
        label: 'Calque > Pixellisation > Texte',
        placement: 'MenuBar',
        name: 'Texte',
    },
    {
        id: 3542,
        label: 'Texte > Pixelliser le calque de texte',
        placement: 'MenuBar',
        name: 'Pixelliser le calque de texte',
    },
    {
        id: 3544,
        label: 'Calque > Pixellisation > Fond',
        placement: 'MenuBar',
        name: 'Fond',
    },
    {
        id: 3545,
        label: 'Calque > Pixellisation > Tous les calques',
        placement: 'MenuBar',
        name: 'Tous les calques',
    },
    {
        id: 3547,
        label: 'Calque > Pixellisation > Calque',
        placement: 'MenuBar',
        name: 'Calque',
    },
    {
        id: 3549,
        label: 'Calque > Objets dynamiques > Pixelliser',
        placement: 'MenuBar',
        name: 'Pixelliser',
    },
    {
        id: 3549,
        label: 'Calque > Pixellisation > Objet dynamique',
        placement: 'MenuBar',
        name: 'Objet dynamique',
    },
    {
        id: 3551,
        label: 'Calque > Pixellisation > Vidéo',
        placement: 'MenuBar',
        name: 'Vidéo',
    },
    {
        id: 3553,
        label: 'Calque > Pixellisation > 3D',
        placement: 'MenuBar',
        name: '3D',
    },
    {
        id: 3555,
        label: 'Calque > Calques vidéo > Pixellisation',
        placement: 'MenuBar',
        name: 'Pixellisation',
    },
    {
        id: 3557,
        label: 'Calque > Pixellisation > Style de calque',
        placement: 'MenuBar',
        name: 'Style de calque',
    },
    {
        id: 3561,
        label: 'Calque > Pixellisation > Génératif',
        placement: 'MenuBar',
        name: 'Génératif',
    },
    {
        id: 3585,
        label: 'Affichage > Afficher > Modifier les épingles',
        placement: 'MenuBar',
        name: 'Modifier les épingles',
    },
    {
        id: 3911,
        label: 'Filtre > Filtres NextGen > Blur (Gaussian)',
        placement: 'MenuBar',
        name: 'Blur (Gaussian)',
    },
    {
        id: 4002,
        label: 'Aide > Mises à jour...',
        placement: 'MenuBar',
        name: 'Mises à jour...',
    },
    {
        id: 4210,
        label: 'Fenêtre > Outils prédéfinis',
        placement: 'MenuBar',
        name: 'Outils prédéfinis',
    },
    {
        id: 5059,
        label: 'Calque > Masque de fusion > Supprimer',
        placement: 'MenuBar',
        name: 'Supprimer',
    },
    {
        id: 5068,
        label: 'Edition > Collage spécial > Coller en dehors',
        placement: 'MenuBar',
        name: 'Coller en dehors',
    },
    {
        id: 5069,
        label: 'Sélection > Mode Masque',
        placement: 'MenuBar',
        name: 'Mode Masque',
    },
    {
        id: 5085,
        label: 'Calque > Masque de fusion > Lier',
        placement: 'MenuBar',
        name: 'Lier',
    },
    {
        id: 5095,
        label: 'Calque > Masque de fusion > Appliquer',
        placement: 'MenuBar',
        name: 'Appliquer',
    },
    {
        id: 5115,
        label: 'Fenêtre > Espace de travail > Nouvel espace de travail...',
        placement: 'MenuBar',
        name: 'Nouvel espace de travail...',
    },
    {
        id: 5116,
        label: "Fenêtre > Espace de travail > Supprimer l'espace de travail...",
        placement: 'MenuBar',
        name: "Supprimer l'espace de travail...",
    },
    {
        id: 5117,
        label: 'Fenêtre > Espace de travail > Réinitialiser Les indispensables',
        placement: 'MenuBar',
        name: 'Réinitialiser Les indispensables',
    },
    {
        id: 5217,
        label: "Calque > Nouvelle tranche d'après un calque",
        placement: 'MenuBar',
        name: "Nouvelle tranche d'après un calque",
    },
    {
        id: 5226,
        label: 'Calque > Filtre dynamique > Supprimer le masque filtrant',
        placement: 'MenuBar',
        name: 'Supprimer le masque filtrant',
    },
    {
        id: 5613,
        label: 'Affichage > Repères > Nouveau repère...',
        placement: 'MenuBar',
        name: 'Nouveau repère...',
    },
    {
        id: 5614,
        label: 'Affichage > Repères > Nouvelle disposition des repères...',
        placement: 'MenuBar',
        name: 'Nouvelle disposition des repères...',
    },
    {
        id: 5615,
        label: 'Affichage > Repères > Nouveaux repères de formes',
        placement: 'MenuBar',
        name: 'Nouveaux repères de formes',
    },
    {
        id: 5624,
        label: 'Edition > Créer une forme personnalisée...',
        placement: 'MenuBar',
        name: 'Créer une forme personnalisée...',
    },
    {
        id: 5634,
        label: 'Fenêtre > Espace de travail > Les indispensables (par défaut)',
        placement: 'MenuBar',
        name: 'Les indispensables (par défaut)',
    },
    {
        id: 5929,
        label: 'Fenêtre > Réorganiser > Tout au premier plan',
        placement: 'MenuBar',
        name: 'Tout au premier plan',
    },
    {
        id: 5930,
        label: 'Fenêtre > Réorganiser > Cascade',
        placement: 'MenuBar',
        name: 'Cascade',
    },
    {
        id: 5931,
        label: 'Fenêtre > Réorganiser > Juxtaposer',
        placement: 'MenuBar',
        name: 'Juxtaposer',
    },
    {
        id: 5932,
        label: 'Fenêtre > Réorganiser > Réduire',
        placement: 'MenuBar',
        name: 'Réduire',
    },
    {
        id: 5933,
        label: 'Fenêtre > Réorganiser > Tout disposer en mosaïque verticale',
        placement: 'MenuBar',
        name: 'Tout disposer en mosaïque verticale',
    },
    {
        id: 5934,
        label: 'Fenêtre > Réorganiser > Tout disposer en mosaïque horizontale',
        placement: 'MenuBar',
        name: 'Tout disposer en mosaïque horizontale',
    },
    {
        id: 5935,
        label: 'Fenêtre > Réorganiser > 2 vignettes horizontales',
        placement: 'MenuBar',
        name: '2 vignettes horizontales',
    },
    {
        id: 5936,
        label: 'Fenêtre > Réorganiser > 2 vignettes verticales',
        placement: 'MenuBar',
        name: '2 vignettes verticales',
    },
    {
        id: 5937,
        label: 'Fenêtre > Réorganiser > 3 vignettes horizontales',
        placement: 'MenuBar',
        name: '3 vignettes horizontales',
    },
    {
        id: 5938,
        label: 'Fenêtre > Réorganiser > 3 vignettes verticales',
        placement: 'MenuBar',
        name: '3 vignettes verticales',
    },
    {
        id: 5939,
        label: 'Fenêtre > Réorganiser > 3 vignettes empilées',
        placement: 'MenuBar',
        name: '3 vignettes empilées',
    },
    {
        id: 5940,
        label: 'Fenêtre > Réorganiser > 4 vignettes',
        placement: 'MenuBar',
        name: '4 vignettes',
    },
    {
        id: 5941,
        label: 'Fenêtre > Réorganiser > 6 vignettes',
        placement: 'MenuBar',
        name: '6 vignettes',
    },
    {
        id: 5956,
        label: 'Aide > Aide de Photoshop...',
        placement: 'MenuBar',
        name: 'Aide de Photoshop...',
    },
    {
        id: 5957,
        label: 'Edition > Rechercher',
        placement: 'MenuBar',
        name: 'Rechercher',
    },
    {
        id: 5960,
        label: 'Fenêtre > Réorganiser > Faire correspondre le zoom',
        placement: 'MenuBar',
        name: 'Faire correspondre le zoom',
    },
    {
        id: 5962,
        label: 'Fenêtre > Réorganiser > Faire correspondre la position',
        placement: 'MenuBar',
        name: 'Faire correspondre la position',
    },
    {
        id: 5963,
        label: 'Fenêtre > Réorganiser > Faire correspondre la rotation',
        placement: 'MenuBar',
        name: 'Faire correspondre la rotation',
    },
    {
        id: 5964,
        label: 'Fenêtre > Réorganiser > Tout faire correspondre',
        placement: 'MenuBar',
        name: 'Tout faire correspondre',
    },
    {
        id: 5966,
        label: 'Fichier > Partager pour révision',
        placement: 'MenuBar',
        name: 'Partager pour révision',
    },
    {
        id: 5967,
        label: 'Fichier > Inviter à modifier...',
        placement: 'MenuBar',
        name: 'Inviter à modifier...',
    },
    {
        id: 5968,
        label: 'Fichier > Exportation > Envoyer à Firefly Boards',
        placement: 'MenuBar',
        name: 'Envoyer à Firefly Boards',
    },
    {
        id: 5980,
        label: 'Edition > Raccourcis clavier...',
        placement: 'MenuBar',
        name: 'Raccourcis clavier...',
    },
    {
        id: 5981,
        label: 'Fenêtre > Espace de travail > Raccourcis clavier et menus...',
        placement: 'MenuBar',
        name: 'Raccourcis clavier et menus...',
    },
    {
        id: 5982,
        label: 'Edition > Menus...',
        placement: 'MenuBar',
        name: 'Menus...',
    },
    {
        id: 5983,
        label: "Edition > Barre d'outils...",
        placement: 'MenuBar',
        name: "Barre d'outils...",
    },
    {
        id: 5991,
        label: "Affichage > Mode d'affichage > Mode Fenêtres standard",
        placement: 'MenuBar',
        name: 'Mode Fenêtres standard',
    },
    {
        id: 5992,
        label: "Affichage > Mode d'affichage > Mode Plein écran avec menus",
        placement: 'MenuBar',
        name: 'Mode Plein écran avec menus',
    },
    {
        id: 5993,
        label: "Affichage > Mode d'affichage > Mode Plein écran sans menus",
        placement: 'MenuBar',
        name: 'Mode Plein écran sans menus',
    },
    {
        id: 5996,
        label: 'Fenêtre > Réorganiser > Afficher dans une fenêtre flottante',
        placement: 'MenuBar',
        name: 'Afficher dans une fenêtre flottante',
    },
    {
        id: 5997,
        label: 'Fenêtre > Réorganiser > Tout afficher dans des fenêtres flottantes',
        placement: 'MenuBar',
        name: 'Tout afficher dans des fenêtres flottantes',
    },
    {
        id: 5998,
        label: 'Fenêtre > Réorganiser > Tout regrouper dans des onglets',
        placement: 'MenuBar',
        name: 'Tout regrouper dans des onglets',
    },
    {
        id: 6300,
        label: 'Calque > Nouveau calque de remplissage > Couleur unie...',
        placement: 'MenuBar',
        name: 'Couleur unie...',
    },
    {
        id: 6301,
        label: 'Calque > Nouveau calque de remplissage > Dégradé...',
        placement: 'MenuBar',
        name: 'Dégradé...',
    },
    {
        id: 6302,
        label: 'Calque > Nouveau calque de remplissage > Motif...',
        placement: 'MenuBar',
        name: 'Motif...',
    },
    {
        id: 6303,
        label: 'Calque > Nouveau calque de réglage > Niveaux...',
        placement: 'MenuBar',
        name: 'Niveaux...',
    },
    {
        id: 6304,
        label: 'Calque > Nouveau calque de réglage > Courbes...',
        placement: 'MenuBar',
        name: 'Courbes...',
    },
    {
        id: 6305,
        label: 'Calque > Nouveau calque de réglage > Balance des couleurs...',
        placement: 'MenuBar',
        name: 'Balance des couleurs...',
    },
    {
        id: 6306,
        label: 'Calque > Nouveau calque de réglage > Luminosité/Contraste...',
        placement: 'MenuBar',
        name: 'Luminosité/Contraste...',
    },
    {
        id: 6308,
        label: 'Calque > Nouveau calque de réglage > Teinte/Saturation...',
        placement: 'MenuBar',
        name: 'Teinte/Saturation...',
    },
    {
        id: 6309,
        label: 'Calque > Nouveau calque de réglage > Correction sélective...',
        placement: 'MenuBar',
        name: 'Correction sélective...',
    },
    {
        id: 6310,
        label: 'Calque > Nouveau calque de réglage > Mélangeur de couches...',
        placement: 'MenuBar',
        name: 'Mélangeur de couches...',
    },
    {
        id: 6311,
        label: 'Calque > Nouveau calque de réglage > Courbe de transfert de dégradé...',
        placement: 'MenuBar',
        name: 'Courbe de transfert de dégradé...',
    },
    {
        id: 6312,
        label: 'Calque > Nouveau calque de réglage > Filtre photo...',
        placement: 'MenuBar',
        name: 'Filtre photo...',
    },
    {
        id: 6313,
        label: 'Calque > Nouveau calque de réglage > Inverser...',
        placement: 'MenuBar',
        name: 'Inverser...',
    },
    {
        id: 6314,
        label: 'Calque > Nouveau calque de réglage > Seuil...',
        placement: 'MenuBar',
        name: 'Seuil...',
    },
    {
        id: 6315,
        label: 'Calque > Nouveau calque de réglage > Isohélie...',
        placement: 'MenuBar',
        name: 'Isohélie...',
    },
    {
        id: 6332,
        label: 'Calque > Objets dynamiques > Modifier le contenu',
        placement: 'MenuBar',
        name: 'Modifier le contenu',
    },
    {
        id: 6333,
        label: 'Calque > Objets dynamiques > Remplacer le contenu...',
        placement: 'MenuBar',
        name: 'Remplacer le contenu...',
    },
    {
        id: 6334,
        label: 'Calque > Objets dynamiques > Exporter le contenu...',
        placement: 'MenuBar',
        name: 'Exporter le contenu...',
    },
    {
        id: 6337,
        label: 'Calque > Nouveau calque de réglage > Correspondance de couleur...',
        placement: 'MenuBar',
        name: 'Correspondance de couleur...',
    },
    {
        id: 6339,
        label: 'Calque > Objets dynamiques > Convertir en élément lié...',
        placement: 'MenuBar',
        name: 'Convertir en élément lié...',
    },
    {
        id: 6340,
        label: 'Calque > Objets dynamiques > Rééditer le lien du fichier...',
        placement: 'MenuBar',
        name: 'Rééditer le lien du fichier...',
    },
    {
        id: 6341,
        label: "Calque > Objets dynamiques > Rééditer le lien de l'image de la bibliothèque...",
        placement: 'MenuBar',
        name: "Rééditer le lien de l'image de la bibliothèque...",
    },
    {
        id: 6342,
        label: 'Calque > Objets dynamiques > Mettre à jour le contenu modifié',
        placement: 'MenuBar',
        name: 'Mettre à jour le contenu modifié',
    },
    {
        id: 6343,
        label: 'Calque > Objets dynamiques > Mettre à jour tout le contenu modifié',
        placement: 'MenuBar',
        name: 'Mettre à jour tout le contenu modifié',
    },
    {
        id: 6345,
        label: 'Calque > Objets dynamiques > Incorporer les éléments liés',
        placement: 'MenuBar',
        name: 'Incorporer les éléments liés',
    },
    {
        id: 6346,
        label: 'Calque > Objets dynamiques > Incorporer tous les éléments liés',
        placement: 'MenuBar',
        name: 'Incorporer tous les éléments liés',
    },
    {
        id: 6347,
        label: 'Calque > Objets dynamiques > Réinitialiser la transformation',
        placement: 'MenuBar',
        name: 'Réinitialiser la transformation',
    },
    {
        id: 6348,
        label: 'Calque > Nouveau calque de réglage > Noir et blanc...',
        placement: 'MenuBar',
        name: 'Noir et blanc...',
    },
    {
        id: 6351,
        label: "Calque > Calques vidéo > Nouveau calque vidéo d'après un fichier...",
        placement: 'MenuBar',
        name: "Nouveau calque vidéo d'après un fichier...",
    },
    {
        id: 6352,
        label: 'Calque > Calques vidéo > Nouveau calque vidéo vide',
        placement: 'MenuBar',
        name: 'Nouveau calque vidéo vide',
    },
    {
        id: 6353,
        label: 'Calque > Calques vidéo > Insérer une image vide',
        placement: 'MenuBar',
        name: 'Insérer une image vide',
    },
    {
        id: 6354,
        label: 'Calque > Calques vidéo > Dupliquer le cadre',
        placement: 'MenuBar',
        name: 'Dupliquer le cadre',
    },
    {
        id: 6355,
        label: "Calque > Calques vidéo > Supprimer l'image",
        placement: 'MenuBar',
        name: "Supprimer l'image",
    },
    {
        id: 6356,
        label: 'Calque > Calques vidéo > Métrage...',
        placement: 'MenuBar',
        name: 'Métrage...',
    },
    {
        id: 6357,
        label: 'Calque > Calques vidéo > Remplacer le métrage...',
        placement: 'MenuBar',
        name: 'Remplacer le métrage...',
    },
    {
        id: 6358,
        label: 'Calque > Calques vidéo > Afficher la vidéo modifiée',
        placement: 'MenuBar',
        name: 'Afficher la vidéo modifiée',
    },
    {
        id: 6360,
        label: "Calque > Calques vidéo > Restaurer l'image",
        placement: 'MenuBar',
        name: "Restaurer l'image",
    },
    {
        id: 6361,
        label: 'Calque > Calques vidéo > Restaurer tous les cadres',
        placement: 'MenuBar',
        name: 'Restaurer tous les cadres',
    },
    {
        id: 6362,
        label: 'Fichier > Importation > Images vidéo dans des calques...',
        placement: 'MenuBar',
        name: 'Images vidéo dans des calques...',
    },
    {
        id: 6363,
        label: 'Calque > Calques vidéo > Recharger le cadre',
        placement: 'MenuBar',
        name: 'Recharger le cadre',
    },
    {
        id: 6400,
        label: "Affichage > Options d'aperçu 32 bits...",
        placement: 'MenuBar',
        name: "Options d'aperçu 32 bits...",
    },
    {
        id: 6432,
        label: "Calque > Objets dynamiques > Mode d'empilement > Sans",
        placement: 'MenuBar',
        name: 'Sans',
    },
    {
        id: 6440,
        label: 'Filtre > Convertir pour les filtres dynamiques',
        placement: 'MenuBar',
        name: 'Convertir pour les filtres dynamiques',
    },
    {
        id: 6478,
        label: 'Fenêtre > Propriétés',
        placement: 'MenuBar',
        name: 'Propriétés',
    },
    {
        id: 6479,
        label: 'Fenêtre > Réglages',
        placement: 'MenuBar',
        name: 'Réglages',
    },
    {
        id: 6651,
        label: 'Calque > Nouveau calque de réglage > Clarté et correction du voile...',
        placement: 'MenuBar',
        name: 'Clarté et correction du voile...',
    },
    {
        id: 6652,
        label: 'Calque > Nouveau calque de réglage > Grain...',
        placement: 'MenuBar',
        name: 'Grain...',
    },
    {
        id: 7763,
        label: 'Fenêtre > Dégradés',
        placement: 'MenuBar',
        name: 'Dégradés',
    },
    {
        id: 7767,
        label: 'Fenêtre > Motifs',
        placement: 'MenuBar',
        name: 'Motifs',
    },
    {
        id: 7772,
        label: 'Fenêtre > Formes',
        placement: 'MenuBar',
        name: 'Formes',
    },
    {
        id: 7788,
        label: 'Fenêtre > Matières',
        placement: 'MenuBar',
        name: 'Matières',
    },
    {
        id: 7789,
        label: 'Filtre > Filtres paramétriques…',
        placement: 'MenuBar',
        name: 'Filtres paramétriques…',
    },
    {
        id: 7800,
        label: "Image > Appliquer l'ensemble de données...",
        placement: 'MenuBar',
        name: "Appliquer l'ensemble de données...",
    },
    {
        id: 7802,
        label: 'Image > Variables > Définir...',
        placement: 'MenuBar',
        name: 'Définir...',
    },
    {
        id: 7803,
        label: 'Image > Variables > Ensembles de données...',
        placement: 'MenuBar',
        name: 'Ensembles de données...',
    },
    {
        id: 7805,
        label: 'Fichier > Importation > Ensembles de données variables...',
        placement: 'MenuBar',
        name: 'Ensembles de données variables...',
    },
    {
        id: 7806,
        label: 'Fichier > Exportation > Ensembles de données sous forme de fichiers...',
        placement: 'MenuBar',
        name: 'Ensembles de données sous forme de fichiers...',
    },
    {
        id: 7900,
        label: 'Image > Analyse > Outil Comptage',
        placement: 'MenuBar',
        name: 'Outil Comptage',
    },
    {
        id: 7930,
        label: "Fenêtre > Cadre de l'application",
        placement: 'MenuBar',
        name: "Cadre de l'application",
    },
    {
        id: 8820,
        label: 'Filtre > Neural Filters...',
        placement: 'MenuBar',
        name: 'Neural Filters...',
    },
    {
        id: 9066,
        label: 'Texte > Panneaux > Panneau Styles de caractère',
        placement: 'MenuBar',
        name: 'Panneau Styles de caractère',
    },
    {
        id: 9066,
        label: 'Fenêtre > Styles de caractères',
        placement: 'MenuBar',
        name: 'Styles de caractères',
    },
    {
        id: 9067,
        label: 'Texte > Panneaux > Panneau Styles de paragraphe',
        placement: 'MenuBar',
        name: 'Panneau Styles de paragraphe',
    },
    {
        id: 9067,
        label: 'Fenêtre > Styles de paragraphes',
        placement: 'MenuBar',
        name: 'Styles de paragraphes',
    },
    {
        id: 9068,
        label: 'Texte > Panneaux > Panneau Glyphes',
        placement: 'MenuBar',
        name: 'Panneau Glyphes',
    },
    {
        id: 9068,
        label: 'Fenêtre > Glyphes',
        placement: 'MenuBar',
        name: 'Glyphes',
    },
    {
        id: 9086,
        label: 'Texte > OpenType > Variantes de justification',
        placement: 'MenuBar',
        name: 'Variantes de justification',
    },
    {
        id: 9087,
        label: 'Texte > Gérer les polices manquantes',
        placement: 'MenuBar',
        name: 'Gérer les polices manquantes',
    },
    {
        id: 9100,
        label: 'Texte > Options de langue > Fonctions par défaut',
        placement: 'MenuBar',
        name: 'Fonctions par défaut',
    },
    {
        id: 9101,
        label: 'Texte > Options de langue > Fonctions est-asiatiques',
        placement: 'MenuBar',
        name: 'Fonctions est-asiatiques',
    },
    {
        id: 9102,
        label: 'Texte > Options de langue > Fonctions moyen-orientales',
        placement: 'MenuBar',
        name: 'Fonctions moyen-orientales',
    },
    {
        id: 9109,
        label: "Texte > Taille d'aperçu de la police > Sans",
        placement: 'MenuBar',
        name: 'Sans',
    },
    {
        id: 9110,
        label: "Texte > Taille d'aperçu de la police > Petite",
        placement: 'MenuBar',
        name: 'Petite',
    },
    {
        id: 9111,
        label: "Texte > Taille d'aperçu de la police > Moyenne",
        placement: 'MenuBar',
        name: 'Moyenne',
    },
    {
        id: 9112,
        label: "Texte > Taille d'aperçu de la police > Grande",
        placement: 'MenuBar',
        name: 'Grande',
    },
    {
        id: 9113,
        label: "Texte > Taille d'aperçu de la police > Très grande",
        placement: 'MenuBar',
        name: 'Très grande',
    },
    {
        id: 9114,
        label: "Texte > Taille d'aperçu de la police > Immense",
        placement: 'MenuBar',
        name: 'Immense',
    },
    {
        id: 9119,
        label: 'Texte > Coller Lorem Ipsum',
        placement: 'MenuBar',
        name: 'Coller Lorem Ipsum',
    },
    {
        id: 9121,
        label: 'Texte > Charger les styles de texte par défaut',
        placement: 'MenuBar',
        name: 'Charger les styles de texte par défaut',
    },
    {
        id: 9122,
        label: 'Texte > Enregistrer les styles de texte par défaut',
        placement: 'MenuBar',
        name: 'Enregistrer les styles de texte par défaut',
    },
    {
        id: 9123,
        label: 'Texte > Trouver une police similaire…',
        placement: 'MenuBar',
        name: 'Trouver une police similaire…',
    },
    {
        id: 9130,
        label: 'Texte > Options de langue > Alignement romain vertical standard',
        placement: 'MenuBar',
        name: 'Alignement romain vertical standard',
    },
    {
        id: 9131,
        label: 'Texte > Options de langue > Tate-chu-yoko',
        placement: 'MenuBar',
        name: 'Tate-chu-yoko',
    },
    {
        id: 9132,
        label: 'Texte > Options de langue > Interlignage typographique',
        placement: 'MenuBar',
        name: 'Interlignage typographique',
    },
    {
        id: 9133,
        label: 'Texte > Options de langue > Interlignage dactylographique',
        placement: 'MenuBar',
        name: 'Interlignage dactylographique',
    },
    {
        id: 9137,
        label: 'Texte > Options de langue > Kashida',
        placement: 'MenuBar',
        name: 'Kashida',
    },
    {
        id: 9138,
        label: 'Texte > Options de langue > Direction par défaut',
        placement: 'MenuBar',
        name: 'Direction par défaut',
    },
    {
        id: 9139,
        label: 'Texte > Options de langue > Sens des caractères gauche - droite',
        placement: 'MenuBar',
        name: 'Sens des caractères gauche - droite',
    },
    {
        id: 9140,
        label: 'Texte > Options de langue > Sens des caractères droite - gauche',
        placement: 'MenuBar',
        name: 'Sens des caractères droite - gauche',
    },
    {
        id: 9143,
        label: 'Edition > Collage spécial > Coller le texte sans formatage',
        placement: 'MenuBar',
        name: 'Coller le texte sans formatage',
    },
    {
        id: 9220,
        label: 'Calque > Nouveau > Plan de travail...',
        placement: 'MenuBar',
        name: 'Plan de travail...',
    },
    {
        id: 9221,
        label: 'Calque > Nouveau > Plan de travail à partir du groupe',
        placement: 'MenuBar',
        name: 'Plan de travail à partir du groupe',
    },
    {
        id: 9222,
        label: 'Calque > Nouveau > Plan de travail à partir des calques…',
        placement: 'MenuBar',
        name: 'Plan de travail à partir des calques…',
    },
    {
        id: 9252,
        label: 'Calque > Nouveau > Cadre à partir des calques...',
        placement: 'MenuBar',
        name: 'Cadre à partir des calques...',
    },
    {
        id: 9255,
        label: 'Calque > Nouveau > Convertir en image',
        placement: 'MenuBar',
        name: 'Convertir en image',
    },
    {
        id: 9600,
        label: 'Fenêtre > Barre des tâches contextuelle',
        placement: 'MenuBar',
        name: 'Barre des tâches contextuelle',
    },
    {
        id: 11600,
        label: 'Calque > Harmoniser',
        placement: 'MenuBar',
        name: 'Harmoniser',
    },
    {
        id: 15004,
        label: 'Aide > Informations sur le système...',
        placement: 'MenuBar',
        name: 'Informations sur le système...',
    },
    {
        id: 15009,
        label: 'Aide > Compatibilité GPU...',
        placement: 'MenuBar',
        name: 'Compatibilité GPU...',
    },
    {
        id: 15019,
        label: 'Aide > En savoir plus sur les crédits génératifs',
        placement: 'MenuBar',
        name: 'En savoir plus sur les crédits génératifs',
    },
    {
        id: 15020,
        label: 'Aide > Consignes d’utilisation de l’IA générative d’Adobe',
        placement: 'MenuBar',
        name: 'Consignes d’utilisation de l’IA générative d’Adobe',
    },
    {
        id: 15201,
        label: 'Fichier > Rechercher dans Adobe Stock...',
        placement: 'MenuBar',
        name: 'Rechercher dans Adobe Stock...',
    },
    {
        id: 15202,
        label: 'Fichier > Rechercher des modèles Adobe Express...',
        placement: 'MenuBar',
        name: 'Rechercher des modèles Adobe Express...',
    },
    {
        id: 15203,
        label: 'Aide > Tutoriels pratiques...',
        placement: 'MenuBar',
        name: 'Tutoriels pratiques...',
    },
    {
        id: 15204,
        label: 'Aide > Nouveautés...',
        placement: 'MenuBar',
        name: 'Nouveautés...',
    },
    {
        id: 17001,
        label: 'Edition > Déformation de perspective',
        placement: 'MenuBar',
        name: 'Déformation de perspective',
    },
    {
        id: 20006,
        label: 'Fichier > Historique des versions',
        placement: 'MenuBar',
        name: 'Historique des versions',
    },
    {
        id: 20007,
        label: 'Fenêtre > Historique des versions',
        placement: 'MenuBar',
        name: 'Historique des versions',
    },
    {
        id: 20008,
        label: 'Fenêtre > Commentaires',
        placement: 'MenuBar',
        name: 'Commentaires',
    },
    {
        id: 21000,
        label: 'Calque > Objets dynamiques > Convertir en calques',
        placement: 'MenuBar',
        name: 'Convertir en calques',
    },
    {
        id: 21001,
        label: "Affichage > Ajuster les calques à l'écran",
        placement: 'MenuBar',
        name: "Ajuster les calques à l'écran",
    },
    {
        id: 22003,
        label: 'Affichage > Repères > Modifier les repères sélectionnés',
        placement: 'MenuBar',
        name: 'Modifier les repères sélectionnés',
    },
    {
        id: 22004,
        label: 'Affichage > Repères > Effacer les repères sélectionnés',
        placement: 'MenuBar',
        name: 'Effacer les repères sélectionnés',
    },
    {
        id: 22100,
        label: 'Calque > Masquer tous les objets',
        placement: 'MenuBar',
        name: 'Masquer tous les objets',
    },
    {
        id: 23150,
        label: 'Filtre > Filtre précédent',
        placement: 'MenuBar',
        name: 'Filtre précédent',
    },
    {
        id: 23151,
        label: 'Filtre > Filtre précédent',
        placement: 'MenuBar',
        name: 'Filtre précédent',
    },
    {
        id: 23152,
        label: 'Filtre > Filtre précédent',
        placement: 'MenuBar',
        name: 'Filtre précédent',
    },
    {
        id: 23153,
        label: 'Filtre > Filtre précédent',
        placement: 'MenuBar',
        name: 'Filtre précédent',
    },
    {
        id: 25070,
        label: 'Edition > Faire pivoter l’objet',
        placement: 'MenuBar',
        name: 'Faire pivoter l’objet',
    },
    {
        id: 26010,
        label: 'Edition > Suppression des reflets...',
        placement: 'MenuBar',
        name: 'Suppression des reflets...',
    },
    {
        id: 30900,
        label: 'Fichier > Importer des images Adobe Stock gratuites…',
        placement: 'MenuBar',
        name: 'Importer des images Adobe Stock gratuites…',
    },
    {
        id: 'paintbrushTool',
        label: 'Outil Pinceau',
        placement: 'Tool',
    },
    {
        id: 'adjustmentBrushTool',
        label: 'Outil Pinceau de réglage',
        placement: 'Tool',
    },
    {
        id: 'pencilTool',
        label: 'Outil Crayon',
        placement: 'Tool',
    },
    {
        id: 'colorReplacementBrushTool',
        label: 'Outil Remplacement de couleur',
        placement: 'Tool',
    },
    {
        id: 'wetBrushTool',
        label: 'Outil Pinceau mélangeur',
        placement: 'Tool',
    },
    {
        id: 'eraserTool',
        label: 'Outil Gomme',
        placement: 'Tool',
    },
    {
        id: 'backgroundEraserTool',
        label: "Outil Gomme d'arrière-plan",
        placement: 'Tool',
    },
    {
        id: 'cloneStampTool',
        label: 'Outil Tampon de duplication',
        placement: 'Tool',
    },
    {
        id: 'patternStampTool',
        label: 'Outil Tampon de motif',
        placement: 'Tool',
    },
    {
        id: 'magicStampTool',
        label: 'Outil Correcteur',
        placement: 'Tool',
    },
    {
        id: 'historyBrushTool',
        label: "Outil Pinceau d'historique",
        placement: 'Tool',
    },
    {
        id: 'artBrushTool',
        label: "Outil Pinceau d'historique artistique",
        placement: 'Tool',
    },
    {
        id: 'smudgeTool',
        label: 'Outil Doigt',
        placement: 'Tool',
    },
    {
        id: 'blurTool',
        label: "Outil Goutte d'eau",
        placement: 'Tool',
    },
    {
        id: 'sharpenTool',
        label: 'Outil Netteté',
        placement: 'Tool',
    },
    {
        id: 'dodgeTool',
        label: 'Outil Densité -',
        placement: 'Tool',
    },
    {
        id: 'burnInTool',
        label: 'Outil Densité +',
        placement: 'Tool',
    },
    {
        id: 'saturationTool',
        label: 'Outil Eponge',
        placement: 'Tool',
    },
    {
        id: 'redEyeTool',
        label: 'Outil Œil rouge',
        placement: 'Tool',
    },
    {
        id: 'marqueeRectTool',
        label: 'Outil Rectangle de sélection',
        placement: 'Tool',
    },
    {
        id: 'marqueeEllipTool',
        label: 'Outil Ellipse de sélection',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleRowTool',
        label: 'Outil Rectangle de sélection 1 rangée',
        placement: 'Tool',
    },
    {
        id: 'marqueeSingleColumnTool',
        label: 'Outil Rectangle de sélection 1 colonne',
        placement: 'Tool',
    },
    {
        id: 'moveTool',
        label: 'Outil Déplacement',
        placement: 'Tool',
    },
    {
        id: 'artboardTool',
        label: 'Outil Plan de travail',
        placement: 'Tool',
    },
    {
        id: 'lassoTool',
        label: 'Outil Lasso',
        placement: 'Tool',
    },
    {
        id: 'selectionBrushTool',
        label: 'Outil Pinceau de sélection',
        placement: 'Tool',
    },
    {
        id: 'magicLassoTool',
        label: "Outil de sélection d'objet",
        placement: 'Tool',
    },
    {
        id: 'polySelTool',
        label: 'Outil Lasso polygonal',
        placement: 'Tool',
    },
    {
        id: 'magneticLassoTool',
        label: 'Outil Lasso magnétique',
        placement: 'Tool',
    },
    {
        id: 'magicWandTool',
        label: 'Outil Baguette magique',
        placement: 'Tool',
    },
    {
        id: 'quickSelectTool',
        label: 'Outil Sélection rapide',
        placement: 'Tool',
    },
    {
        id: 'cropTool',
        label: 'Outil Recadrage',
        placement: 'Tool',
    },
    {
        id: 'perspectiveCropTool',
        label: 'Outil Correction de perspective par recadrage',
        placement: 'Tool',
    },
    {
        id: 'sliceTool',
        label: 'Outil Tranche',
        placement: 'Tool',
    },
    {
        id: 'sliceSelectTool',
        label: 'Outil Sélection de tranche',
        placement: 'Tool',
    },
    {
        id: 'magicEraserTool',
        label: 'Outil Gomme magique',
        placement: 'Tool',
    },
    {
        id: 'gradientTool',
        label: 'Outil Dégradé',
        placement: 'Tool',
    },
    {
        id: 'bucketTool',
        label: 'Outil Pot de peinture',
        placement: 'Tool',
    },
    {
        id: 'pathComponentSelectTool',
        label: 'Outil Sélection de tracé',
        placement: 'Tool',
    },
    {
        id: 'directSelectTool',
        label: 'Outil Sélection directe',
        placement: 'Tool',
    },
    {
        id: 'penTool',
        label: 'Outil Plume',
        placement: 'Tool',
    },
    {
        id: 'freeformPenTool',
        label: 'Outil Plume libre',
        placement: 'Tool',
    },
    {
        id: 'curvaturePenTool',
        label: 'Outil Plume de courbure',
        placement: 'Tool',
    },
    {
        id: 'addKnotTool',
        label: "Outil Ajout de point d'ancrage",
        placement: 'Tool',
    },
    {
        id: 'deleteKnotTool',
        label: "Outil Suppression de point d'ancrage",
        placement: 'Tool',
    },
    {
        id: 'convertKnotTool',
        label: 'Outil Conversion de point',
        placement: 'Tool',
    },
    {
        id: 'typeCreateOrEditTool',
        label: 'Outil Texte horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateOrEditTool',
        label: 'Outil Texte vertical',
        placement: 'Tool',
    },
    {
        id: 'typeCreateMaskTool',
        label: 'Outil Masque de texte horizontal',
        placement: 'Tool',
    },
    {
        id: 'typeVerticalCreateMaskTool',
        label: 'Outil Masque de texte vertical',
        placement: 'Tool',
    },
    {
        id: 'rectangleTool',
        label: 'Outil Rectangle',
        placement: 'Tool',
    },
    {
        id: 'ellipseTool',
        label: 'Outil Ellipse',
        placement: 'Tool',
    },
    {
        id: 'triangleTool',
        label: 'Outil Triangle',
        placement: 'Tool',
    },
    {
        id: 'polygonTool',
        label: 'Outil Polygone',
        placement: 'Tool',
    },
    {
        id: 'lineTool',
        label: 'Outil Trait',
        placement: 'Tool',
    },
    {
        id: 'customShapeTool',
        label: 'Outil Forme personnalisée',
        placement: 'Tool',
    },
    {
        id: 'StarTool',
        label: 'Outil Étoile',
        placement: 'Tool',
    },
    {
        id: 'framedGroupTool',
        label: 'Outil Cadre',
        placement: 'Tool',
    },
    {
        id: 'eyedropperTool',
        label: 'Outil Pipette',
        placement: 'Tool',
    },
    {
        id: 'colorSamplerTool',
        label: 'Outil Echantillonnage de couleur',
        placement: 'Tool',
    },
    {
        id: 'rulerTool',
        label: 'Outil Règle',
        placement: 'Tool',
    },
    {
        id: 'textAnnotTool',
        label: 'Outil Annotation',
        placement: 'Tool',
    },
    {
        id: 'handTool',
        label: 'Outil Main',
        placement: 'Tool',
    },
    {
        id: 'rotateTool',
        label: "Outil Rotation de l'affichage",
        placement: 'Tool',
    },
    {
        id: 'zoomTool',
        label: 'Outil Zoom',
        placement: 'Tool',
    },
    {
        id: 'patchSelection',
        label: 'Outil Pièce',
        placement: 'Tool',
    },
    {
        id: 'recomposeSelection',
        label: 'Outil Déplacement basé sur le contenu',
        placement: 'Tool',
    },
    {
        id: 'spotHealingBrushTool',
        label: 'Outil Correcteur localisé',
        placement: 'Tool',
    },
    {
        id: 'removeTool',
        label: 'Outil Supprimer',
        placement: 'Tool',
    },
    {
        id: 'editToolbar',
        label: "Modifier la barre d'outils...",
        placement: 'Tool',
    },
    {
        id: 'countTool',
        label: 'Outil Comptage',
        placement: 'Tool',
    },
    {
        id: 'panelid.static.actions',
        label: 'Actions',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.gradients',
        label: 'Dégradés',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.styles',
        label: 'Styles',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.swatches',
        label: 'Nuancier',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.patterns',
        label: 'Motifs',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.histogram',
        label: 'Histogramme',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.info',
        label: 'Informations',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.paths',
        label: 'Tracés',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.customshapes',
        label: 'Formes',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.toolpresets',
        label: 'Outils prédéfinis',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.picker',
        label: 'Couleur',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.channels',
        label: 'Couches',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.layers',
        label: 'Calques',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.comps',
        label: 'Compositions de calques',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.animation',
        label: 'Montage',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.clonesource',
        label: 'Source de duplication',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.measurement',
        label: 'Journal des mesures',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.hdrpreview',
        label: 'Aperçu HDR',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.history',
        label: 'Historique',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.navigator',
        label: 'Navigation',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharacter',
        label: 'Caractère',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparagraph',
        label: 'Paragraphe',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textcharstyle',
        label: 'Styles de caractères',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textparastyle',
        label: 'Styles de paragraphes',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.textglyphspanel',
        label: 'Glyphes',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.annotation',
        label: 'Annotations',
        placement: 'Panel',
    },
    {
        id: 'panelid.static.properties',
        label: 'Propriétés',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cai.uxp/panel',
        label: 'Content Credentials (Beta)',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.cclibrariespanel/ccLibrariesPanel',
        label: 'Bibliothèques',
        placement: 'Panel',
    },
    {
        id: 'panelid.dynamic.uxp/com.adobe.ccx.comments-webview/ccx-comments-uxp-webview',
        label: 'Commentaires',
        placement: 'Panel',
    },
    {
        id: 'actionId:$dytx;selectorId:context_bar',
        label: 'Barre contextuelle : Texte dynamique',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:properties',
        label: 'Panneau : Texte dynamique',
        placement: 'Option',
    },
    {
        id: 'actionId:$dytx;selectorId:options',
        label: 'Outil : Texte dynamique',
        placement: 'Option',
    },
];
